// Internal logging interface, which writes messages to the console.
function createConsoleLogger(level, maybePrefix) {
  var allLevels = ['debug', 'info', 'warn', 'error'];
  var prefix;

  if (maybePrefix !== null && maybePrefix !== undefined) {
    prefix = maybePrefix === '' ? '' : "".concat(maybePrefix, " ");
  } else {
    prefix = 'FeatureToggle: ';
  }

  var minLevelIndex = 0;

  if (level) {
    if (level === 'none') {
      minLevelIndex = 100;
    } else {
      minLevelIndex = allLevels.indexOf(level);
    }
  }

  var logger = {};

  function log(levelIndex, outputFn, msg) {
    if (levelIndex >= minLevelIndex) {
      var levelName = levelIndex < allLevels.length ? allLevels[levelIndex] : '?';
      outputFn("".concat(prefix, "[").concat(levelName, "] ").concat(msg));
    }
  }

  logger.debug = function (msg) {
    return log(0, console.log, msg);
  };

  logger.info = function (msg) {
    return log(1, console.info, msg);
  };

  logger.warn = function (msg) {
    return log(2, console.warn, msg);
  };

  logger.error = function (msg) {
    return log(3, console.error, msg);
  };

  return logger;
}

function EventEmitter(logger) {
  var emitter = {};
  var events = {};

  var listeningTo = function listeningTo(event) {
    return !!events[event];
  };

  emitter.on = function (event, handler, context) {
    events[event] = events[event] || [];
    events[event] = events[event].concat({
      handler: handler,
      context: context
    });
  };

  emitter.off = function (event, handler, context) {
    if (!events[event]) {
      return;
    }

    for (var i = events[event].length - 1; i >= 0; i--) {
      if (events[event][i].handler === handler && events[event][i].context === context) {
        events[event] = events[event].slice(0, i).concat(events[event].slice(i + 1));
      }
    }
  };

  emitter.emit = function (event) {
    if (!events[event]) {
      return;
    }

    for (var i = 0; i < events[event].length; i++) {
      events[event][i].handler.apply(events[event][i].context, Array.prototype.slice.call(arguments, 1));
    }
  };

  emitter.getEvents = function () {
    return Object.keys(events);
  };

  emitter.getEventListenerCount = function (event) {
    return events[event] ? events[event].length : 0;
  };

  emitter.maybeReportError = function (error) {
    if (!error) {
      return;
    }

    if (listeningTo('error')) {
      this.emit('error', error);
    } else {
      (logger || console).error(error.message);
    }
  };

  emitter.maybeReportWarn = function (error) {
    if (!error) {
      return;
    }

    if (listeningTo('warn')) {
      this.emit('warn', error);
    } else {
      (logger || console).warn(error.message);
    }
  };

  return emitter;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var rngBrowser = createCommonjsModule(function (module) {
  // Unique ID creation requires a high quality random # generator.  In the
  // browser this is a little complicated due to unknown quality of Math.random()
  // and inconsistent support for the `crypto` API.  We do the best we can via
  // feature-detection
  // getRandomValues needs to be invoked in a context where "this" is a Crypto
  // implementation. Also, find the complete implementation of crypto on IE11.
  var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

  if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

    module.exports = function whatwgRNG() {
      getRandomValues(rnds8);
      return rnds8;
    };
  } else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);

    module.exports = function mathRNG() {
      for (var i = 0, r; i < 16; i++) {
        if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
        rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
      }

      return rnds;
    };
  }
});

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

var bytesToUuid_1 = bytesToUuid;

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || rngBrowser)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid_1(rnds);
}

var v4_1 = v4;

var core = createCommonjsModule(function (module, exports) {

  (function (root, factory) {
    {
      // CommonJS
      module.exports = exports = factory();
    }
  })(commonjsGlobal, function () {
    /**
     * CryptoJS core components.
     */
    var CryptoJS = CryptoJS || function (Math, undefined$1) {
      /*
       * Local polyfil of Object.create
       */
      var create = Object.create || function () {
        function F() {}
        return function (obj) {
          var subtype;
          F.prototype = obj;
          subtype = new F();
          F.prototype = null;
          return subtype;
        };
      }();
      /**
       * CryptoJS namespace.
       */


      var C = {};
      /**
       * Library namespace.
       */

      var C_lib = C.lib = {};
      /**
       * Base object for prototypal inheritance.
       */

      var Base = C_lib.Base = function () {
        return {
          /**
           * Creates a new object that inherits from this object.
           *
           * @param {Object} overrides Properties to copy into the new object.
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         field: 'value',
           *
           *         method: function () {
           *         }
           *     });
           */
          extend: function (overrides) {
            // Spawn
            var subtype = create(this); // Augment

            if (overrides) {
              subtype.mixIn(overrides);
            } // Create default initializer


            if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
              subtype.init = function () {
                subtype.$super.init.apply(this, arguments);
              };
            } // Initializer's prototype is the subtype object


            subtype.init.prototype = subtype; // Reference supertype

            subtype.$super = this;
            return subtype;
          },

          /**
           * Extends this object and runs the init method.
           * Arguments to create() will be passed to init().
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var instance = MyType.create();
           */
          create: function () {
            var instance = this.extend();
            instance.init.apply(instance, arguments);
            return instance;
          },

          /**
           * Initializes a newly created object.
           * Override this method to add some logic when your objects are created.
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         init: function () {
           *             // ...
           *         }
           *     });
           */
          init: function () {},

          /**
           * Copies properties into this object.
           *
           * @param {Object} properties The properties to mix in.
           *
           * @example
           *
           *     MyType.mixIn({
           *         field: 'value'
           *     });
           */
          mixIn: function (properties) {
            for (var propertyName in properties) {
              if (properties.hasOwnProperty(propertyName)) {
                this[propertyName] = properties[propertyName];
              }
            } // IE won't copy toString using the loop above


            if (properties.hasOwnProperty('toString')) {
              this.toString = properties.toString;
            }
          },

          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = instance.clone();
           */
          clone: function () {
            return this.init.prototype.extend(this);
          }
        };
      }();
      /**
       * An array of 32-bit words.
       *
       * @property {Array} words The array of 32-bit words.
       * @property {number} sigBytes The number of significant bytes in this word array.
       */


      var WordArray = C_lib.WordArray = Base.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of 32-bit words.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.create();
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
         */
        init: function (words, sigBytes) {
          words = this.words = words || [];

          if (sigBytes != undefined$1) {
            this.sigBytes = sigBytes;
          } else {
            this.sigBytes = words.length * 4;
          }
        },

        /**
         * Converts this word array to a string.
         *
         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
         *
         * @return {string} The stringified word array.
         *
         * @example
         *
         *     var string = wordArray + '';
         *     var string = wordArray.toString();
         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
         */
        toString: function (encoder) {
          return (encoder || Hex).stringify(this);
        },

        /**
         * Concatenates a word array to this word array.
         *
         * @param {WordArray} wordArray The word array to append.
         *
         * @return {WordArray} This word array.
         *
         * @example
         *
         *     wordArray1.concat(wordArray2);
         */
        concat: function (wordArray) {
          // Shortcuts
          var thisWords = this.words;
          var thatWords = wordArray.words;
          var thisSigBytes = this.sigBytes;
          var thatSigBytes = wordArray.sigBytes; // Clamp excess bits

          this.clamp(); // Concat

          if (thisSigBytes % 4) {
            // Copy one byte at a time
            for (var i = 0; i < thatSigBytes; i++) {
              var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
              thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
            }
          } else {
            // Copy one word at a time
            for (var i = 0; i < thatSigBytes; i += 4) {
              thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
            }
          }

          this.sigBytes += thatSigBytes; // Chainable

          return this;
        },

        /**
         * Removes insignificant bits.
         *
         * @example
         *
         *     wordArray.clamp();
         */
        clamp: function () {
          // Shortcuts
          var words = this.words;
          var sigBytes = this.sigBytes; // Clamp

          words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
          words.length = Math.ceil(sigBytes / 4);
        },

        /**
         * Creates a copy of this word array.
         *
         * @return {WordArray} The clone.
         *
         * @example
         *
         *     var clone = wordArray.clone();
         */
        clone: function () {
          var clone = Base.clone.call(this);
          clone.words = this.words.slice(0);
          return clone;
        },

        /**
         * Creates a word array filled with random bytes.
         *
         * @param {number} nBytes The number of random bytes to generate.
         *
         * @return {WordArray} The random word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.random(16);
         */
        random: function (nBytes) {
          var words = [];

          var r = function (m_w) {
            var m_w = m_w;
            var m_z = 0x3ade68b1;
            var mask = 0xffffffff;
            return function () {
              m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
              m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
              var result = (m_z << 0x10) + m_w & mask;
              result /= 0x100000000;
              result += 0.5;
              return result * (Math.random() > .5 ? 1 : -1);
            };
          };

          for (var i = 0, rcache; i < nBytes; i += 4) {
            var _r = r((rcache || Math.random()) * 0x100000000);

            rcache = _r() * 0x3ade67b7;
            words.push(_r() * 0x100000000 | 0);
          }

          return new WordArray.init(words, nBytes);
        }
      });
      /**
       * Encoder namespace.
       */

      var C_enc = C.enc = {};
      /**
       * Hex encoding strategy.
       */

      var Hex = C_enc.Hex = {
        /**
         * Converts a word array to a hex string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The hex string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
         */
        stringify: function (wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes; // Convert

          var hexChars = [];

          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
            hexChars.push((bite >>> 4).toString(16));
            hexChars.push((bite & 0x0f).toString(16));
          }

          return hexChars.join('');
        },

        /**
         * Converts a hex string to a word array.
         *
         * @param {string} hexStr The hex string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
         */
        parse: function (hexStr) {
          // Shortcut
          var hexStrLength = hexStr.length; // Convert

          var words = [];

          for (var i = 0; i < hexStrLength; i += 2) {
            words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
          }

          return new WordArray.init(words, hexStrLength / 2);
        }
      };
      /**
       * Latin1 encoding strategy.
       */

      var Latin1 = C_enc.Latin1 = {
        /**
         * Converts a word array to a Latin1 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Latin1 string.
         *
         * @static
         *
         * @example
         *
         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
         */
        stringify: function (wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes; // Convert

          var latin1Chars = [];

          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
            latin1Chars.push(String.fromCharCode(bite));
          }

          return latin1Chars.join('');
        },

        /**
         * Converts a Latin1 string to a word array.
         *
         * @param {string} latin1Str The Latin1 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
         */
        parse: function (latin1Str) {
          // Shortcut
          var latin1StrLength = latin1Str.length; // Convert

          var words = [];

          for (var i = 0; i < latin1StrLength; i++) {
            words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
          }

          return new WordArray.init(words, latin1StrLength);
        }
      };
      /**
       * UTF-8 encoding strategy.
       */

      var Utf8 = C_enc.Utf8 = {
        /**
         * Converts a word array to a UTF-8 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-8 string.
         *
         * @static
         *
         * @example
         *
         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
         */
        stringify: function (wordArray) {
          try {
            return decodeURIComponent(escape(Latin1.stringify(wordArray)));
          } catch (e) {
            throw new Error('Malformed UTF-8 data');
          }
        },

        /**
         * Converts a UTF-8 string to a word array.
         *
         * @param {string} utf8Str The UTF-8 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
         */
        parse: function (utf8Str) {
          return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
      };
      /**
       * Abstract buffered block algorithm template.
       *
       * The property blockSize must be implemented in a concrete subtype.
       *
       * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
       */

      var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        /**
         * Resets this block algorithm's data buffer to its initial state.
         *
         * @example
         *
         *     bufferedBlockAlgorithm.reset();
         */
        reset: function () {
          // Initial values
          this._data = new WordArray.init();
          this._nDataBytes = 0;
        },

        /**
         * Adds new data to this block algorithm's buffer.
         *
         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
         *
         * @example
         *
         *     bufferedBlockAlgorithm._append('data');
         *     bufferedBlockAlgorithm._append(wordArray);
         */
        _append: function (data) {
          // Convert string to WordArray, else assume WordArray already
          if (typeof data == 'string') {
            data = Utf8.parse(data);
          } // Append


          this._data.concat(data);

          this._nDataBytes += data.sigBytes;
        },

        /**
         * Processes available data blocks.
         *
         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
         *
         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
         *
         * @return {WordArray} The processed data.
         *
         * @example
         *
         *     var processedData = bufferedBlockAlgorithm._process();
         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
         */
        _process: function (doFlush) {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var dataSigBytes = data.sigBytes;
          var blockSize = this.blockSize;
          var blockSizeBytes = blockSize * 4; // Count blocks ready

          var nBlocksReady = dataSigBytes / blockSizeBytes;

          if (doFlush) {
            // Round up to include partial blocks
            nBlocksReady = Math.ceil(nBlocksReady);
          } else {
            // Round down to include only full blocks,
            // less the number of blocks that must remain in the buffer
            nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
          } // Count words ready


          var nWordsReady = nBlocksReady * blockSize; // Count bytes ready

          var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes); // Process blocks

          if (nWordsReady) {
            for (var offset = 0; offset < nWordsReady; offset += blockSize) {
              // Perform concrete-algorithm logic
              this._doProcessBlock(dataWords, offset);
            } // Remove processed words


            var processedWords = dataWords.splice(0, nWordsReady);
            data.sigBytes -= nBytesReady;
          } // Return processed words


          return new WordArray.init(processedWords, nBytesReady);
        },

        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = bufferedBlockAlgorithm.clone();
         */
        clone: function () {
          var clone = Base.clone.call(this);
          clone._data = this._data.clone();
          return clone;
        },
        _minBufferSize: 0
      });
      /**
       * Abstract hasher template.
       *
       * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
       */

      var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
        /**
         * Configuration options.
         */
        cfg: Base.extend(),

        /**
         * Initializes a newly created hasher.
         *
         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
         *
         * @example
         *
         *     var hasher = CryptoJS.algo.SHA256.create();
         */
        init: function (cfg) {
          // Apply config defaults
          this.cfg = this.cfg.extend(cfg); // Set initial values

          this.reset();
        },

        /**
         * Resets this hasher to its initial state.
         *
         * @example
         *
         *     hasher.reset();
         */
        reset: function () {
          // Reset data buffer
          BufferedBlockAlgorithm.reset.call(this); // Perform concrete-hasher logic

          this._doReset();
        },

        /**
         * Updates this hasher with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {Hasher} This hasher.
         *
         * @example
         *
         *     hasher.update('message');
         *     hasher.update(wordArray);
         */
        update: function (messageUpdate) {
          // Append
          this._append(messageUpdate); // Update the hash


          this._process(); // Chainable


          return this;
        },

        /**
         * Finalizes the hash computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The hash.
         *
         * @example
         *
         *     var hash = hasher.finalize();
         *     var hash = hasher.finalize('message');
         *     var hash = hasher.finalize(wordArray);
         */
        finalize: function (messageUpdate) {
          // Final message update
          if (messageUpdate) {
            this._append(messageUpdate);
          } // Perform concrete-hasher logic


          var hash = this._doFinalize();

          return hash;
        },
        blockSize: 512 / 32,

        /**
         * Creates a shortcut function to a hasher's object interface.
         *
         * @param {Hasher} hasher The hasher to create a helper for.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
         */
        _createHelper: function (hasher) {
          return function (message, cfg) {
            return new hasher.init(cfg).finalize(message);
          };
        },

        /**
         * Creates a shortcut function to the HMAC's object interface.
         *
         * @param {Hasher} hasher The hasher to use in this HMAC helper.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
         */
        _createHmacHelper: function (hasher) {
          return function (message, key) {
            return new C_algo.HMAC.init(hasher, key).finalize(message);
          };
        }
      });
      /**
       * Algorithm namespace.
       */

      var C_algo = C.algo = {};
      return C;
    }(Math);

    return CryptoJS;
  });
});

var encBase64 = createCommonjsModule(function (module, exports) {

  (function (root, factory) {
    {
      // CommonJS
      module.exports = exports = factory(core);
    }
  })(commonjsGlobal, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var C_enc = C.enc;
      /**
       * Base64 encoding strategy.
       */

      var Base64 = C_enc.Base64 = {
        /**
         * Converts a word array to a Base64 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Base64 string.
         *
         * @static
         *
         * @example
         *
         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
         */
        stringify: function (wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var map = this._map; // Clamp excess bits

          wordArray.clamp(); // Convert

          var base64Chars = [];

          for (var i = 0; i < sigBytes; i += 3) {
            var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
            var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
            var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
            var triplet = byte1 << 16 | byte2 << 8 | byte3;

            for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
              base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
            }
          } // Add padding


          var paddingChar = map.charAt(64);

          if (paddingChar) {
            while (base64Chars.length % 4) {
              base64Chars.push(paddingChar);
            }
          }

          return base64Chars.join('');
        },

        /**
         * Converts a Base64 string to a word array.
         *
         * @param {string} base64Str The Base64 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
         */
        parse: function (base64Str) {
          // Shortcuts
          var base64StrLength = base64Str.length;
          var map = this._map;
          var reverseMap = this._reverseMap;

          if (!reverseMap) {
            reverseMap = this._reverseMap = [];

            for (var j = 0; j < map.length; j++) {
              reverseMap[map.charCodeAt(j)] = j;
            }
          } // Ignore padding


          var paddingChar = map.charAt(64);

          if (paddingChar) {
            var paddingIndex = base64Str.indexOf(paddingChar);

            if (paddingIndex !== -1) {
              base64StrLength = paddingIndex;
            }
          } // Convert


          return parseLoop(base64Str, base64StrLength, reverseMap);
        },
        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
      };

      function parseLoop(base64Str, base64StrLength, reverseMap) {
        var words = [];
        var nBytes = 0;

        for (var i = 0; i < base64StrLength; i++) {
          if (i % 4) {
            var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
            var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
            words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
            nBytes++;
          }
        }

        return WordArray.create(words, nBytes);
      }
    })();

    return CryptoJS.enc.Base64;
  });
});

var encUtf8 = createCommonjsModule(function (module, exports) {

  (function (root, factory) {
    {
      // CommonJS
      module.exports = exports = factory(core);
    }
  })(commonjsGlobal, function (CryptoJS) {
    return CryptoJS.enc.Utf8;
  });
});

var murmurHash3js = createCommonjsModule(function (module, exports) {

  (function (root, undefined$1) {

    var library = {
      'version': '3.0.1',
      'x86': {},
      'x64': {}
    }; // PRIVATE FUNCTIONS
    // -----------------

    function _x86Multiply(m, n) {
      //
      // Given two 32bit ints, returns the two multiplied together as a
      // 32bit int.
      //
      return (m & 0xffff) * n + (((m >>> 16) * n & 0xffff) << 16);
    }

    function _x86Rotl(m, n) {
      //
      // Given a 32bit int and an int representing a number of bit positions,
      // returns the 32bit int rotated left by that number of positions.
      //
      return m << n | m >>> 32 - n;
    }

    function _x86Fmix(h) {
      //
      // Given a block, returns murmurHash3's final x86 mix of that block.
      //
      h ^= h >>> 16;
      h = _x86Multiply(h, 0x85ebca6b);
      h ^= h >>> 13;
      h = _x86Multiply(h, 0xc2b2ae35);
      h ^= h >>> 16;
      return h;
    }

    function _x64Add(m, n) {
      //
      // Given two 64bit ints (as an array of two 32bit ints) returns the two
      // added together as a 64bit int (as an array of two 32bit ints).
      //
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] + n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] + n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] + n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] + n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }

    function _x64Multiply(m, n) {
      //
      // Given two 64bit ints (as an array of two 32bit ints) returns the two
      // multiplied together as a 64bit int (as an array of two 32bit ints).
      //
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] * n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] * n[3];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[2] += m[3] * n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] * n[3];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[2] * n[2];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[3] * n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }

    function _x64Rotl(m, n) {
      //
      // Given a 64bit int (as an array of two 32bit ints) and an int
      // representing a number of bit positions, returns the 64bit int (as an
      // array of two 32bit ints) rotated left by that number of positions.
      //
      n %= 64;

      if (n === 32) {
        return [m[1], m[0]];
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n | m[0] >>> 32 - n];
      } else {
        n -= 32;
        return [m[1] << n | m[0] >>> 32 - n, m[0] << n | m[1] >>> 32 - n];
      }
    }

    function _x64LeftShift(m, n) {
      //
      // Given a 64bit int (as an array of two 32bit ints) and an int
      // representing a number of bit positions, returns the 64bit int (as an
      // array of two 32bit ints) shifted left by that number of positions.
      //
      n %= 64;

      if (n === 0) {
        return m;
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n];
      } else {
        return [m[1] << n - 32, 0];
      }
    }

    function _x64Xor(m, n) {
      //
      // Given two 64bit ints (as an array of two 32bit ints) returns the two
      // xored together as a 64bit int (as an array of two 32bit ints).
      //
      return [m[0] ^ n[0], m[1] ^ n[1]];
    }

    function _x64Fmix(h) {
      //
      // Given a block, returns murmurHash3's final x64 mix of that block.
      // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
      // only place where we need to right shift 64bit ints.)
      //
      h = _x64Xor(h, [0, h[0] >>> 1]);
      h = _x64Multiply(h, [0xff51afd7, 0xed558ccd]);
      h = _x64Xor(h, [0, h[0] >>> 1]);
      h = _x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
      h = _x64Xor(h, [0, h[0] >>> 1]);
      return h;
    } // PUBLIC FUNCTIONS
    // ----------------


    library.x86.hash32 = function (key, seed) {
      //
      // Given a string and an optional seed as an int, returns a 32 bit hash
      // using the x86 flavor of MurmurHash3, as an unsigned int.
      //
      key = key || '';
      seed = seed || 0;
      var remainder = key.length % 4;
      var bytes = key.length - remainder;
      var h1 = seed;
      var k1 = 0;
      var c1 = 0xcc9e2d51;
      var c2 = 0x1b873593;

      for (var i = 0; i < bytes; i = i + 4) {
        k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24;
        k1 = _x86Multiply(k1, c1);
        k1 = _x86Rotl(k1, 15);
        k1 = _x86Multiply(k1, c2);
        h1 ^= k1;
        h1 = _x86Rotl(h1, 13);
        h1 = _x86Multiply(h1, 5) + 0xe6546b64;
      }

      k1 = 0;

      switch (remainder) {
        case 3:
          k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;

        case 2:
          k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;

        case 1:
          k1 ^= key.charCodeAt(i) & 0xff;
          k1 = _x86Multiply(k1, c1);
          k1 = _x86Rotl(k1, 15);
          k1 = _x86Multiply(k1, c2);
          h1 ^= k1;
      }

      h1 ^= key.length;
      h1 = _x86Fmix(h1);
      return h1 >>> 0;
    };

    library.x86.hash128 = function (key, seed) {
      //
      // Given a string and an optional seed as an int, returns a 128 bit
      // hash using the x86 flavor of MurmurHash3, as an unsigned hex.
      //
      key = key || '';
      seed = seed || 0;
      var remainder = key.length % 16;
      var bytes = key.length - remainder;
      var h1 = seed;
      var h2 = seed;
      var h3 = seed;
      var h4 = seed;
      var k1 = 0;
      var k2 = 0;
      var k3 = 0;
      var k4 = 0;
      var c1 = 0x239b961b;
      var c2 = 0xab0e9789;
      var c3 = 0x38b34ae5;
      var c4 = 0xa1e38b93;

      for (var i = 0; i < bytes; i = i + 16) {
        k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24;
        k2 = key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24;
        k3 = key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24;
        k4 = key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24;
        k1 = _x86Multiply(k1, c1);
        k1 = _x86Rotl(k1, 15);
        k1 = _x86Multiply(k1, c2);
        h1 ^= k1;
        h1 = _x86Rotl(h1, 19);
        h1 += h2;
        h1 = _x86Multiply(h1, 5) + 0x561ccd1b;
        k2 = _x86Multiply(k2, c2);
        k2 = _x86Rotl(k2, 16);
        k2 = _x86Multiply(k2, c3);
        h2 ^= k2;
        h2 = _x86Rotl(h2, 17);
        h2 += h3;
        h2 = _x86Multiply(h2, 5) + 0x0bcaa747;
        k3 = _x86Multiply(k3, c3);
        k3 = _x86Rotl(k3, 17);
        k3 = _x86Multiply(k3, c4);
        h3 ^= k3;
        h3 = _x86Rotl(h3, 15);
        h3 += h4;
        h3 = _x86Multiply(h3, 5) + 0x96cd1c35;
        k4 = _x86Multiply(k4, c4);
        k4 = _x86Rotl(k4, 18);
        k4 = _x86Multiply(k4, c1);
        h4 ^= k4;
        h4 = _x86Rotl(h4, 13);
        h4 += h1;
        h4 = _x86Multiply(h4, 5) + 0x32ac3b17;
      }

      k1 = 0;
      k2 = 0;
      k3 = 0;
      k4 = 0;

      switch (remainder) {
        case 15:
          k4 ^= key.charCodeAt(i + 14) << 16;

        case 14:
          k4 ^= key.charCodeAt(i + 13) << 8;

        case 13:
          k4 ^= key.charCodeAt(i + 12);
          k4 = _x86Multiply(k4, c4);
          k4 = _x86Rotl(k4, 18);
          k4 = _x86Multiply(k4, c1);
          h4 ^= k4;

        case 12:
          k3 ^= key.charCodeAt(i + 11) << 24;

        case 11:
          k3 ^= key.charCodeAt(i + 10) << 16;

        case 10:
          k3 ^= key.charCodeAt(i + 9) << 8;

        case 9:
          k3 ^= key.charCodeAt(i + 8);
          k3 = _x86Multiply(k3, c3);
          k3 = _x86Rotl(k3, 17);
          k3 = _x86Multiply(k3, c4);
          h3 ^= k3;

        case 8:
          k2 ^= key.charCodeAt(i + 7) << 24;

        case 7:
          k2 ^= key.charCodeAt(i + 6) << 16;

        case 6:
          k2 ^= key.charCodeAt(i + 5) << 8;

        case 5:
          k2 ^= key.charCodeAt(i + 4);
          k2 = _x86Multiply(k2, c2);
          k2 = _x86Rotl(k2, 16);
          k2 = _x86Multiply(k2, c3);
          h2 ^= k2;

        case 4:
          k1 ^= key.charCodeAt(i + 3) << 24;

        case 3:
          k1 ^= key.charCodeAt(i + 2) << 16;

        case 2:
          k1 ^= key.charCodeAt(i + 1) << 8;

        case 1:
          k1 ^= key.charCodeAt(i);
          k1 = _x86Multiply(k1, c1);
          k1 = _x86Rotl(k1, 15);
          k1 = _x86Multiply(k1, c2);
          h1 ^= k1;
      }

      h1 ^= key.length;
      h2 ^= key.length;
      h3 ^= key.length;
      h4 ^= key.length;
      h1 += h2;
      h1 += h3;
      h1 += h4;
      h2 += h1;
      h3 += h1;
      h4 += h1;
      h1 = _x86Fmix(h1);
      h2 = _x86Fmix(h2);
      h3 = _x86Fmix(h3);
      h4 = _x86Fmix(h4);
      h1 += h2;
      h1 += h3;
      h1 += h4;
      h2 += h1;
      h3 += h1;
      h4 += h1;
      return ("00000000" + (h1 >>> 0).toString(16)).slice(-8) + ("00000000" + (h2 >>> 0).toString(16)).slice(-8) + ("00000000" + (h3 >>> 0).toString(16)).slice(-8) + ("00000000" + (h4 >>> 0).toString(16)).slice(-8);
    };

    library.x64.hash128 = function (key, seed) {
      //
      // Given a string and an optional seed as an int, returns a 128 bit
      // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
      //
      key = key || '';
      seed = seed || 0;
      var remainder = key.length % 16;
      var bytes = key.length - remainder;
      var h1 = [0, seed];
      var h2 = [0, seed];
      var k1 = [0, 0];
      var k2 = [0, 0];
      var c1 = [0x87c37b91, 0x114253d5];
      var c2 = [0x4cf5ad43, 0x2745937f];

      for (var i = 0; i < bytes; i = i + 16) {
        k1 = [key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24, key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24];
        k2 = [key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24, key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24];
        k1 = _x64Multiply(k1, c1);
        k1 = _x64Rotl(k1, 31);
        k1 = _x64Multiply(k1, c2);
        h1 = _x64Xor(h1, k1);
        h1 = _x64Rotl(h1, 27);
        h1 = _x64Add(h1, h2);
        h1 = _x64Add(_x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
        k2 = _x64Multiply(k2, c2);
        k2 = _x64Rotl(k2, 33);
        k2 = _x64Multiply(k2, c1);
        h2 = _x64Xor(h2, k2);
        h2 = _x64Rotl(h2, 31);
        h2 = _x64Add(h2, h1);
        h2 = _x64Add(_x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
      }

      k1 = [0, 0];
      k2 = [0, 0];

      switch (remainder) {
        case 15:
          k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 14)], 48));

        case 14:
          k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 13)], 40));

        case 13:
          k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 12)], 32));

        case 12:
          k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 11)], 24));

        case 11:
          k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 10)], 16));

        case 10:
          k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 9)], 8));

        case 9:
          k2 = _x64Xor(k2, [0, key.charCodeAt(i + 8)]);
          k2 = _x64Multiply(k2, c2);
          k2 = _x64Rotl(k2, 33);
          k2 = _x64Multiply(k2, c1);
          h2 = _x64Xor(h2, k2);

        case 8:
          k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 7)], 56));

        case 7:
          k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 6)], 48));

        case 6:
          k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 5)], 40));

        case 5:
          k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 4)], 32));

        case 4:
          k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 3)], 24));

        case 3:
          k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 2)], 16));

        case 2:
          k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 1)], 8));

        case 1:
          k1 = _x64Xor(k1, [0, key.charCodeAt(i)]);
          k1 = _x64Multiply(k1, c1);
          k1 = _x64Rotl(k1, 31);
          k1 = _x64Multiply(k1, c2);
          h1 = _x64Xor(h1, k1);
      }

      h1 = _x64Xor(h1, [0, key.length]);
      h2 = _x64Xor(h2, [0, key.length]);
      h1 = _x64Add(h1, h2);
      h2 = _x64Add(h2, h1);
      h1 = _x64Fmix(h1);
      h2 = _x64Fmix(h2);
      h1 = _x64Add(h1, h2);
      h2 = _x64Add(h2, h1);
      return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
    }; // INITIALIZATION
    // --------------
    // Export murmurHash3 for CommonJS, either as an AMD module or just as part
    // of the global object.


    {
      if ( module.exports) {
        exports = module.exports = library;
      }

      exports.murmurHash3 = library;
    }
  })();
});
var murmurHash3js_1 = murmurHash3js.murmurHash3;

var murmurhash3js = murmurHash3js;

var sha256 = createCommonjsModule(function (module, exports) {

  (function (root, factory) {
    {
      // CommonJS
      module.exports = exports = factory(core);
    }
  })(commonjsGlobal, function (CryptoJS) {
    (function (Math) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C.algo; // Initialization and round constants tables

      var H = [];
      var K = []; // Compute constants

      (function () {
        function isPrime(n) {
          var sqrtN = Math.sqrt(n);

          for (var factor = 2; factor <= sqrtN; factor++) {
            if (!(n % factor)) {
              return false;
            }
          }

          return true;
        }

        function getFractionalBits(n) {
          return (n - (n | 0)) * 0x100000000 | 0;
        }

        var n = 2;
        var nPrime = 0;

        while (nPrime < 64) {
          if (isPrime(n)) {
            if (nPrime < 8) {
              H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
            }

            K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
            nPrime++;
          }

          n++;
        }
      })(); // Reusable object


      var W = [];
      /**
       * SHA-256 hash algorithm.
       */

      var SHA256 = C_algo.SHA256 = Hasher.extend({
        _doReset: function () {
          this._hash = new WordArray.init(H.slice(0));
        },
        _doProcessBlock: function (M, offset) {
          // Shortcut
          var H = this._hash.words; // Working variables

          var a = H[0];
          var b = H[1];
          var c = H[2];
          var d = H[3];
          var e = H[4];
          var f = H[5];
          var g = H[6];
          var h = H[7]; // Computation

          for (var i = 0; i < 64; i++) {
            if (i < 16) {
              W[i] = M[offset + i] | 0;
            } else {
              var gamma0x = W[i - 15];
              var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
              var gamma1x = W[i - 2];
              var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
              W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
            }

            var ch = e & f ^ ~e & g;
            var maj = a & b ^ a & c ^ b & c;
            var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
            var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
            var t1 = h + sigma1 + ch + K[i] + W[i];
            var t2 = sigma0 + maj;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
          } // Intermediate hash value


          H[0] = H[0] + a | 0;
          H[1] = H[1] + b | 0;
          H[2] = H[2] + c | 0;
          H[3] = H[3] + d | 0;
          H[4] = H[4] + e | 0;
          H[5] = H[5] + f | 0;
          H[6] = H[6] + g | 0;
          H[7] = H[7] + h | 0;
        },
        _doFinalize: function () {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8; // Add padding

          dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
          data.sigBytes = dataWords.length * 4; // Hash final blocks

          this._process(); // Return final computed hash


          return this._hash;
        },
        clone: function () {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.SHA256('message');
       *     var hash = CryptoJS.SHA256(wordArray);
       */

      C.SHA256 = Hasher._createHelper(SHA256);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacSHA256(message, key);
       */

      C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);

    return CryptoJS.SHA256;
  });
});

var hmac = createCommonjsModule(function (module, exports) {

  (function (root, factory) {
    {
      // CommonJS
      module.exports = exports = factory(core);
    }
  })(commonjsGlobal, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var Base = C_lib.Base;
      var C_enc = C.enc;
      var Utf8 = C_enc.Utf8;
      var C_algo = C.algo;
      /**
       * HMAC algorithm.
       */

      var HMAC = C_algo.HMAC = Base.extend({
        /**
         * Initializes a newly created HMAC.
         *
         * @param {Hasher} hasher The hash algorithm to use.
         * @param {WordArray|string} key The secret key.
         *
         * @example
         *
         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
         */
        init: function (hasher, key) {
          // Init hasher
          hasher = this._hasher = new hasher.init(); // Convert string to WordArray, else assume WordArray already

          if (typeof key == 'string') {
            key = Utf8.parse(key);
          } // Shortcuts


          var hasherBlockSize = hasher.blockSize;
          var hasherBlockSizeBytes = hasherBlockSize * 4; // Allow arbitrary length keys

          if (key.sigBytes > hasherBlockSizeBytes) {
            key = hasher.finalize(key);
          } // Clamp excess bits


          key.clamp(); // Clone key for inner and outer pads

          var oKey = this._oKey = key.clone();
          var iKey = this._iKey = key.clone(); // Shortcuts

          var oKeyWords = oKey.words;
          var iKeyWords = iKey.words; // XOR keys with pad constants

          for (var i = 0; i < hasherBlockSize; i++) {
            oKeyWords[i] ^= 0x5c5c5c5c;
            iKeyWords[i] ^= 0x36363636;
          }

          oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes; // Set initial values

          this.reset();
        },

        /**
         * Resets this HMAC to its initial state.
         *
         * @example
         *
         *     hmacHasher.reset();
         */
        reset: function () {
          // Shortcut
          var hasher = this._hasher; // Reset

          hasher.reset();
          hasher.update(this._iKey);
        },

        /**
         * Updates this HMAC with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {HMAC} This HMAC instance.
         *
         * @example
         *
         *     hmacHasher.update('message');
         *     hmacHasher.update(wordArray);
         */
        update: function (messageUpdate) {
          this._hasher.update(messageUpdate); // Chainable


          return this;
        },

        /**
         * Finalizes the HMAC computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The HMAC.
         *
         * @example
         *
         *     var hmac = hmacHasher.finalize();
         *     var hmac = hmacHasher.finalize('message');
         *     var hmac = hmacHasher.finalize(wordArray);
         */
        finalize: function (messageUpdate) {
          // Shortcut
          var hasher = this._hasher; // Compute HMAC

          var innerHash = hasher.finalize(messageUpdate);
          hasher.reset();
          var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
          return hmac;
        }
      });
    })();
  });
});

var hmacSha256 = createCommonjsModule(function (module, exports) {

  (function (root, factory, undef) {
    {
      // CommonJS
      module.exports = exports = factory(core, sha256, hmac);
    }
  })(commonjsGlobal, function (CryptoJS) {
    return CryptoJS.HmacSHA256;
  });
});

function base64url(source) {
  // Encode in classical base64
  var encodedSource = encBase64.stringify(source); // Remove padding equal characters

  encodedSource = encodedSource.replace(/=+$/, ''); // Replace characters according to base64url specifications

  encodedSource = encodedSource.replace(/\+/g, '-');
  encodedSource = encodedSource.replace(/\//g, '_');
  return encodedSource;
}

function createJwt(payload, secretKey) {
  var header = {
    alg: "HS256",
    typ: "JWT"
  };
  var stringifiedHeader = encUtf8.parse(JSON.stringify(header));
  var encodedHeader = base64url(stringifiedHeader);
  var stringifiedData = encUtf8.parse(JSON.stringify(payload));
  var encodedData = base64url(stringifiedData);
  var token = "".concat(encodedHeader, ".").concat(encodedData);
  var signature = hmacSha256(token, secretKey);
  signature = base64url(signature);
  var signedToken = "".concat(token, ".").concat(signature);
  return signedToken;
}

function createCustomError(name) {
  function CustomError(message, code) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    this.message = message;
    this.code = code;
  }

  CustomError.prototype = new Error();
  CustomError.prototype.name = name;
  CustomError.prototype.constructor = CustomError;
  return CustomError;
}

var ToggleUnexpectedResponseError = createCustomError('ToggleUnexpectedResponseError');
var ToggleInvalidArgumentError = createCustomError('ToggleInvalidArgumentError');
var ToggleFetchError = createCustomError('ToggleFetchError');
var ToggleInvalidSetNameError = createCustomError('ToggleInvalidSetNameError');
var ToggleNotConfiguredError = createCustomError('ToggleNotConfiguredError');
var ToggleBadFeatureError = createCustomError('ToggleBadFeatureError');

var errors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ToggleUnexpectedResponseError: ToggleUnexpectedResponseError,
  ToggleInvalidArgumentError: ToggleInvalidArgumentError,
  ToggleFetchError: ToggleFetchError,
  ToggleInvalidSetNameError: ToggleInvalidSetNameError,
  ToggleNotConfiguredError: ToggleNotConfiguredError,
  ToggleBadFeatureError: ToggleBadFeatureError
});

var REQ_CONTEXT_KEY_JWT_TOKEN = 'Authorization';
var REQ_JWT_TOKEN_PREFIX = 'Bearer ';
var INCREMENT_UPDATE_VERSION_HEADER = '1.3.0';
var SHANGHAI_TIME_OFFSET = -480;
var VERSION_REG = /([0-9]+\.)?([0-9]+\.)?[0-9]+/;
function assertTypedValue(value, type) {
  return value !== null && _typeof(value) === type;
}
function onNextTick(cb) {
  setTimeout(cb, 0);
}
function formatDate(date) {
  var month = String(date.getMonth() + 1);
  month = month.length < 2 ? "0".concat(month) : month;
  var day = String(date.getDate());
  day = day.length < 2 ? "0".concat(day) : day;
  var hour = String(date.getHours());
  hour = hour.length < 2 ? "0".concat(hour) : hour;
  var minutes = String(date.getMinutes());
  minutes = minutes.length < 2 ? "0".concat(minutes) : minutes;
  var seconds = String(date.getSeconds());
  seconds = seconds.length < 2 ? "0".concat(seconds) : seconds;
  return "".concat(date.getFullYear(), "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minutes, ":").concat(seconds);
}

function getCommonHeaders(productEn) {
  return {
    sn: v4_1(),
    productNameEn: productEn,
    sdkType: 'JavaScript',
    sdkVersion: "1.10.7",
    jceVersion: INCREMENT_UPDATE_VERSION_HEADER
  };
}

function extend() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return objects.reduce(function (acc, obj) {
    return _objectSpread2(_objectSpread2({}, acc), obj);
  }, {});
}
function wrapPromiseCallback(promise, callback) {
  var ret = promise.then(function (value) {
    if (callback) {
      setTimeout(function () {
        callback(null, value);
      }, 0);
    }

    return value;
  }, function (error) {
    if (callback) {
      setTimeout(function () {
        callback(error, null);
      }, 0);
    } else {
      return Promise.reject(error);
    }
  });
  return !callback ? ret : undefined;
}
function getHeaderWithJwt(productKey, productEn, serverTimeDiff) {
  var config = {
    iss: productEn,
    exp: Math.floor(new Date() / 1000) + serverTimeDiff + 60 * 60 // 60 minutes then expired

  };

  var jwtHeader = _defineProperty({}, REQ_CONTEXT_KEY_JWT_TOKEN, REQ_JWT_TOKEN_PREFIX + createJwt(config, productKey));

  var commonHeader = getCommonHeaders(productEn);
  return extend(commonHeader, jwtHeader);
} // 401 may caused by jwt token auth failed

function handle401Response(options, resp) {
  var respData = JSON.parse(resp.body);
  var shouldRetry = options.configureServerTimeDiffFromMsg(respData.msg);
  return shouldRetry;
}
function getShanghaiTime(timestamp) {
  var crtOffset = new Date().getTimezoneOffset();

  if (timestamp) {
    return new Date(timestamp + (SHANGHAI_TIME_OFFSET - crtOffset) * 60 * 1000);
  }

  var crtTimeStamp = Date.now();
  return new Date(crtTimeStamp + (SHANGHAI_TIME_OFFSET - crtOffset) * 60 * 1000);
}
function getAdjustedShanghaiTime(serverTimeDiff) {
  // get server timestamp
  var adjustedTimestamp = Math.floor(Date.now() / 1000) + serverTimeDiff; // server timestamp to shanghai time

  return new Date(getShanghaiTime(adjustedTimestamp * 1000));
}
function easyEncrypt(data) {
  return encBase64.stringify(encUtf8.parse(data));
}
function easyDecrypty(data) {
  return encUtf8.stringify(encBase64.parse(data));
}
function applyDefaults(config, defaults) {
  // Different from utils.extend(), where override a default value if the 
  // provided value is explicitly set to null
  var ret = extend({}, config);
  Object.keys(defaults).forEach(function (name) {
    if (ret[name] === undefined || ret[name] === null) {
      ret[name] = defaults[name];
    }
  });
  return ret;
}
function reportArgumentError(message, emitter) {
  onNextTick(function () {
    emitter && emitter.maybeReportError(new ToggleInvalidArgumentError(message));
  });
} // 统一判断,平级判断，相当于同时执行多个if，上下判断没有关联

function judgeKeyVaild(obj, emitter) {
  obj.length > 0 && obj.map(function (item) {
    var key = item.key,
        message = item.message,
        callback = item.callback;

    if (key) {
      message && reportArgumentError(message, emitter);
      callback && callback();
    }
  });
}
function getRandomPercentNumber() {
  return Math.floor(Math.random() * 100) + 1;
}
function getHashPercentNumber(id) {
  var normalizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return murmurhash3js.x86.hash32(id) % normalizer + 1;
}
function getVersion(version) {
  var versions = version.match(VERSION_REG);

  if (!versions || versions.length === 0) {
    throw new Error('Toggle version is missing');
  }

  return versions[0];
}

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  assertTypedValue: assertTypedValue,
  onNextTick: onNextTick,
  formatDate: formatDate,
  extend: extend,
  wrapPromiseCallback: wrapPromiseCallback,
  getHeaderWithJwt: getHeaderWithJwt,
  handle401Response: handle401Response,
  getShanghaiTime: getShanghaiTime,
  getAdjustedShanghaiTime: getAdjustedShanghaiTime,
  easyEncrypt: easyEncrypt,
  easyDecrypty: easyDecrypty,
  applyDefaults: applyDefaults,
  reportArgumentError: reportArgumentError,
  judgeKeyVaild: judgeKeyVaild,
  getRandomPercentNumber: getRandomPercentNumber,
  getHashPercentNumber: getHashPercentNumber,
  getVersion: getVersion
});

function errorString(err) {
  if (err && err.message) {
    return err.message;
  }

  if (typeof err === 'string' || err instanceof String) {
    return err;
  }

  return JSON.stringify(err);
}

var clientInitialized = function clientInitialized() {
  return 'Feature Toggle client initialized';
};
var debugEnqueueingEvent = function debugEnqueueingEvent() {
  return 'enqueueing event';
};
var debugPositionEvents = function debugPositionEvents(count) {
  return "sending ".concat(count, " events");
};
var debugInitWithLocalStorage = function debugInitWithLocalStorage() {
  return 'initialized with local storage';
};
var debugInitWithFetch = function debugInitWithFetch() {
  return 'initialized with fetch';
};
var httpErrorMessage = function httpErrorMessage(status, context) {
  return "Received error ".concat(status, " for ").concat(context);
};
var setNameNotFound = function setNameNotFound() {
  return 'Set name is not found. Trying to re-get set name.';
};
var errorFetchingFeatures = function errorFetchingFeatures(err, type) {
  return "Error fetching features, received error ".concat(errorString(err), ", in ").concat(type);
};
var httpUnavailable = function httpUnavailable() {
  return 'Cannot make HTTP requests in this environment.';
};
var networkError = function networkError(e) {
  return "network error".concat(e ? " (".concat(e, "\uFF09") : '');
};
var emptySetNameError = function emptySetNameError() {
  return 'Fetching features with empty set name, about to retry.';
};
var localStorageUnavailable = function localStorageUnavailable() {
  return 'localStorage is unavailable';
};
var malformedFeatureError = function malformedFeatureError(key, type) {
  return "Malformed feature ".concat(key, ", strategies not an array, is a ").concat(type, ".");
};
var missingStrategyError = function missingStrategyError(featureName, strategyName) {
  return "Missing strategy ".concat(strategyName, " for ").concat(featureName);
};
var unitedIsEnabledError = function unitedIsEnabledError(name, fallback) {
  return "Feature Toggle is not initialized yet, querying feature ".concat(name, " gets a default value ").concat(!!fallback);
};

var messages = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clientInitialized: clientInitialized,
  debugEnqueueingEvent: debugEnqueueingEvent,
  debugPositionEvents: debugPositionEvents,
  debugInitWithLocalStorage: debugInitWithLocalStorage,
  debugInitWithFetch: debugInitWithFetch,
  httpErrorMessage: httpErrorMessage,
  setNameNotFound: setNameNotFound,
  errorFetchingFeatures: errorFetchingFeatures,
  httpUnavailable: httpUnavailable,
  networkError: networkError,
  emptySetNameError: emptySetNameError,
  localStorageUnavailable: localStorageUnavailable,
  malformedFeatureError: malformedFeatureError,
  missingStrategyError: missingStrategyError,
  unitedIsEnabledError: unitedIsEnabledError
});

var MAX_HTTP_RETRY = 3;
var HTTP_OK_CODE = 200;
var HTTP_UNAUTHORIZED_CODE = 401;
var HTTP_NOT_FOUND_CODE = 404;
var HTTP_SERVER_ERROR_CODE = 500;
var SET_MIGRATION_CODE = 100302;
var FEATURE_VALUE_STR_TRUE = 'true';
var STG_RELATION_AND = 2;
var FEATURE_TIME_LIMIT_TYPE_DAILY = 2;
var FEATURE_TIME_LIMIT_TYPE_FIXED = 3;
var WHITE_LIST = 'whitelist';
var BLACK_LIST = 'blacklist';
var MATCH_TYPE_EQUAL = 'equal';
var MATCH_TYPE_REG = 'regexp';
var TabToggleValField = '_feature_flag_status';
var TabToggleNameField = '_feature_flag_key';
var TabToggleOff = '0';
var TabToggleOn = '1';
var ROMA_AB_TEST = 'roma';
var TAB_AB_TEST = 'tab';
var WithoutDataset = 0;
var WithDataset = 1;
var DatasetTypePrecise = 1;
var DatasetTypePercentage = 2;
var DataTypeMap = 'MAP';
var DataTypeString = 'STRING';
var DataTypeBool = 'BOOL';
var DataTypeFloat = 'FLOAT';
var DataTypeList = 'LIST';
var DataTypeJSON = 'JSON';

function Storage(localStorageProvider, options, logger) {
  var store = {};

  function getFeaturesKey() {
    return "tf-".concat(options.productId, "-").concat(options.moduleId);
  } // Returns a Promise which will be resolved with a parsed JSON value if a stored value was available,
  // resolved with null if there was no value, or rejected if storage was not available.


  store.loadFeatures = function () {
    return localStorageProvider.get(getFeaturesKey()).then(function (dataStr) {
      var nextData = dataStr;

      if (nextData === null || nextData === undefined) {
        return null;
      }

      if (options.encodeCache) {
        nextData = easyDecrypty(nextData);
      }

      try {
        var data = JSON.parse(nextData);
        return data;
      } catch (ex) {
        return store.clearFeatures().then(function () {
          return Promise.reject(ex);
        });
      }
    }).catch(function (err) {
      logger.warn(localStorageUnavailable());
      return Promise.reject(err);
    });
  }; // Returns a Promise which will be resolved with no value if successful, or rejected if storage
  // was not available.


  store.saveFeatures = function (features) {
    var dataStr = JSON.stringify(features);

    if (options.encodeCache) {
      dataStr = easyEncrypt(dataStr);
    }

    return localStorageProvider.set(getFeaturesKey(), dataStr).catch(function (err) {
      logger.warn(localStorageUnavailable());
      return Promise.reject(err);
    });
  }; // Returns a Promise which will be resolved with no value if successful, or rejected if storage
  // was not available.


  store.clearFeatures = function () {
    return localStorageProvider.clear(getFeaturesKey()).catch(function (err) {
      logger.warn(localStorageUnavailable());
      return Promise.reject(err);
    });
  };

  store.syncLoadFeatures = function () {
    var dataStr = localStorageProvider.syncGet(getFeaturesKey());

    try {
      try {
        if (options.encodeCache) {
          dataStr = easyDecrypty(dataStr);
        }

        var data = JSON.parse(dataStr);
        return data;
      } catch (ex) {
        return store.syncClearFeatures();
      }
    } catch (ex) {
      logger.warn(localStorageUnavailable());
    }
  };

  store.syncClearFeatures = function () {
    return localStorageProvider.syncClear(getFeaturesKey());
  };

  return store;
}

var errorType = ['fetching', 'getting set name'];
var readyEvent = 'ready';
var fetchEvent = 'fetched';
var triggerEvent = 'triggered';
var changeEvent = 'changed';
var errorEvent = 'error';
var tabCache = {
  appid: '',
  guid: '',
  tabInfo: {}
};
var TimeStampNeedFullUpdate = 0;

function getResponseError(result, type) {
  return new ToggleFetchError(errorFetchingFeatures(result.status, type));
}

function Repository(platform, options, enqueueEvent) {
  var emitter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var store = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var configSuffix = 'product-set-json';
  var accessDomain = options.accessDomain;
  var logger = options.logger;
  var storage = store || Storage(platform.localStorage, options, logger);
  var repository = {};
  var cloudMode = options.cloudMode;
  var refreshInterval = options.refreshInterval;
  var fetchTimer;
  var cachedData = {
    featureData: {},
    prerequisite: {}
  };
  var featureSimpleMap = {};
  var inited = false;
  var setName = '';
  var lastUpdateTimeStamp = TimeStampNeedFullUpdate;
  var closed;
  var fetchSuffix;

  if (cloudMode === true) {
    fetchSuffix = 'feature-result-json';
  } else {
    fetchSuffix = 'feature-with-strategy-json';
  }

  function getSetConfig() {
    if (!platform.httpRequest) {
      onNextTick(function () {
        emitter.maybeReportError(new ToggleFetchError(httpUnavailable()));
      });
      return Promise.resolve();
    }

    var canPost = platform.httpAllowsPost();
    return canPost ? productHttpRequest(MAX_HTTP_RETRY) : Promise.resolve();
  }

  function fetch() {
    if (!platform.httpRequest) {
      onNextTick(function () {
        emitter.maybeReportError(new ToggleFetchError(httpUnavailable()));
      });
      return Promise.resolve();
    }

    if (!setName) {
      if (inited) {
        onNextTick(function () {
          emitter.maybeReportError(new ToggleFetchError(emptySetNameError()));
        });
      }

      return getSetConfig();
    }

    var canPost = platform.httpAllowsPost();
    return canPost ? featureHttpRequest(MAX_HTTP_RETRY) : Promise.resolve();
  }

  function setFeatures(respData) {
    var data = respData.data || [];
    var prerequisites = respData.prerequisites || [];
    var featureMap = mapNameToFeature(data);
    var prerequisiteMap = mapVersionIdToFeature(prerequisites);
    var featureSM = mapIdToFeatureName(data);
    var storageData = {
      featureData: featureMap,
      prerequisite: prerequisiteMap
    };
    var isFullUpdate = false;
    var removed = []; // increment field determines whether to do incremental update

    if (!respData.increment) {
      // summarize changes
      isFullUpdate = true; // full update

      cachedData = storageData;
      featureSimpleMap = featureSM;
    } else {
      var toDelete = respData.deletedFeatures || []; // summarize changes

      var _iterator = _createForOfIteratorHelper(toDelete),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var id = _step.value;
          var f = cachedData.featureData[featureSimpleMap[id]];

          if (f) {
            removed.push(f);
          }
        } // incremental update

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      incUpdate(featureMap, prerequisiteMap, featureSimpleMap, toDelete);
      incUpdateSimpleMap(featureSM, toDelete);
    }

    lastUpdateTimeStamp = respData.timestamp || TimeStampNeedFullUpdate;
    var patch = {
      data: respData.data,
      prerequiste: respData.prerequisites
    };
    var changes = {
      isFullUpdate: isFullUpdate,
      patch: patch,
      removed: removed
    };
    onNextTick(function () {
      return emitter.emit(changeEvent, changes);
    });
    return storage.saveFeatures(cachedData);
  }

  function incUpdate() {
    var featureToUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var prerequisiteMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var featureSimpleMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var featureToDelete = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    if (!cachedData || Object.keys(cachedData.featureData).length === 0) {
      cachedData = {
        featureData: featureToUpdate,
        prerequisite: prerequisiteMap
      };
    } else {
      // add or update
      for (var _i = 0, _Object$keys = Object.keys(featureToUpdate); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        cachedData.featureData[key] = featureToUpdate[key];
      } // delete


      var _iterator2 = _createForOfIteratorHelper(featureToDelete),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var id = _step2.value;
          delete cachedData.featureData[featureSimpleMap[id]];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      cachedData.prerequisite = prerequisiteMap;
    }
  }

  function incUpdateSimpleMap() {
    var featureSM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var featureToDelete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!featureSimpleMap || Object.keys(featureSimpleMap).length === 0) {
      featureSimpleMap = featureSM;
      return featureSimpleMap;
    } // add and update


    for (var _i2 = 0, _Object$keys2 = Object.keys(featureSM); _i2 < _Object$keys2.length; _i2++) {
      var id = _Object$keys2[_i2];
      featureSimpleMap[+id] = featureSM[+id];
    } // delete


    var _iterator3 = _createForOfIteratorHelper(featureToDelete),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _id = _step3.value;
        delete featureSimpleMap[_id];
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  function getLocalIdList() {
    if (lastUpdateTimeStamp === TimeStampNeedFullUpdate) {
      return [];
    }

    var ids = [];

    for (var _i3 = 0, _Object$keys3 = Object.keys(featureSimpleMap); _i3 < _Object$keys3.length; _i3++) {
      var id = _Object$keys3[_i3];
      ids.push(+id);
    }

    return ids;
  }

  function finishInit() {
    if (options.useLocalStorage) {
      return storage.loadFeatures().catch(function () {
        return null;
      }) // treat an error the same as if no flags were available
      .then(function (storedFeatures) {
        if (!storedFeatures) {
          cachedData = {
            featureData: {},
            prerequisite: {}
          };
        } else {
          logger.debug(debugInitWithLocalStorage());
          cachedData = storedFeatures;

          if (!inited) {
            inited = true;
            onNextTick(function () {
              return emitter.emit(readyEvent);
            });
          }
        }

        return getSetConfig();
      });
    }

    return getSetConfig();
  }

  function uninitedIsEnabled(key, fallback) {
    emitter.maybeReportWarn(new ToggleBadFeatureError(unitedIsEnabledError(key, fallback)));
    return !!fallback;
  }

  function getStrategy(name) {
    var _iterator4 = _createForOfIteratorHelper(options.strategies),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var strategy = _step4.value;

        if (strategy.name === name) {
          return strategy;
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return null;
  }

  function mapNameToFeature(data) {
    var featureMap = {};
    data.forEach(function (d) {
      if (d.name !== undefined) {
        featureMap[d.name] = d;
      }
    });
    return featureMap;
  }

  function mapVersionIdToFeature(prerequisite) {
    var prerequisiteMap = {};
    prerequisite === null || prerequisite === void 0 ? void 0 : prerequisite.forEach(function (d) {
      if (d.id !== undefined) {
        prerequisiteMap[d.id] = d;
      }
    });
    return prerequisiteMap;
  }

  function mapIdToFeatureName(data) {
    var featureSimpleMap = {};
    data.forEach(function (d) {
      if (d.id && d.name) {
        featureSimpleMap[d.id] = d.name;
      }
    });
    return featureSimpleMap;
  }

  function getAbTestInfoValueAndDataset(abTestInfo, wantParamKey) {
    if (!abTestInfo || Object.keys(abTestInfo).length === 0) {
      return {};
    }

    if (!abTestInfo.platform) {
      // 给予默认值，向前兼容Roma实验
      abTestInfo.platform = ROMA_AB_TEST;
    }

    if (!abTestInfo.abTestId || typeof abTestInfo.abTestId !== 'string') {
      return {};
    }

    if (abTestInfo.platform === ROMA_AB_TEST) {
      if (!abTestInfo.params || _typeof(abTestInfo.params) !== 'object') {
        return {};
      }

      if (typeof abTestInfo.params[wantParamKey] !== 'string') {
        return {};
      }

      return {
        toggleValue: abTestInfo.params[wantParamKey] === FEATURE_VALUE_STR_TRUE
      };
    } else if (abTestInfo.platform === TAB_AB_TEST) {
      // 先判断用户是否手动传参数信息到abTestInfo中, 如果有就优先使用
      if (!!abTestInfo.params && !!abTestInfo.params[TabToggleValField]) {
        if (abTestInfo.params[TabToggleValField] === TabToggleOn) {
          return {
            toggleValue: true,
            dataset: abTestInfo.params,
            type: DataTypeMap
          };
        }

        return {
          toggleValue: false,
          dataset: abTestInfo.params,
          type: DataTypeMap
        };
      }

      var expInfo = tabCache.tabInfo[abTestInfo.abTestId];

      if (!!expInfo && !!expInfo.params && expInfo.params[TabToggleNameField] === wantParamKey) {
        if (expInfo.params[TabToggleValField] === TabToggleOn) {
          return {
            toggleValue: true,
            dataset: expInfo.params,
            type: DataTypeMap
          };
        } else if (expInfo.params[TabToggleValField] === TabToggleOff) {
          return {
            toggleValue: false,
            dataset: expInfo.params,
            type: DataTypeMap
          };
        }

        return {};
      }
    }

    return {};
  }

  function timeLimitMatch(timeLimitType, timeStr, crt, isStart) {
    var nextTimeStr = timeStr;

    if (!nextTimeStr) {
      return true;
    }

    if (timeLimitType === FEATURE_TIME_LIMIT_TYPE_DAILY) {
      nextTimeStr = "2006-03-04 ".concat(nextTimeStr);
    }

    var toCompare = new Date(nextTimeStr); // error handling

    if (isNaN(toCompare.valueOf())) {
      return false;
    }

    if (isStart) {
      return toCompare.valueOf() <= crt.valueOf();
    } else {
      return crt.valueOf() <= toCompare.valueOf();
    }
  }

  function checkTimeLimitsMatch(type, timeLimits, serverTimeDiff) {
    if (type === FEATURE_TIME_LIMIT_TYPE_DAILY || type === FEATURE_TIME_LIMIT_TYPE_FIXED) {
      var crtTime = getAdjustedShanghaiTime(serverTimeDiff);

      if (type === FEATURE_TIME_LIMIT_TYPE_DAILY) {
        // mock YYYY-MM-DD
        crtTime = new Date("2006-03-04 ".concat(crtTime.getHours(), ":").concat(crtTime.getMinutes(), ":").concat(crtTime.getSeconds()));
      }

      var _iterator5 = _createForOfIteratorHelper(timeLimits),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var tl = _step5.value;

          if (timeLimitMatch(type, tl.startTime, crtTime, true) && timeLimitMatch(type, tl.endTime, crtTime, false)) {
            return true;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return false; // miss
    }

    return true;
  }

  function isEnabledCalculator(feature, context, hasCaculatedMap) {
    var hasDataset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : WithoutDataset;
    var featureIdStr = feature.id.toString();

    if (hasCaculatedMap[featureIdStr] !== undefined) {
      return {
        toggleValue: hasCaculatedMap[featureIdStr]
      };
    }

    if (feature.value !== FEATURE_VALUE_STR_TRUE) {
      hasCaculatedMap[featureIdStr] = false;
      return {
        toggleValue: false
      };
    }

    if (!checkTimeLimitsMatch(feature.timeLimitType, feature.timeLimits, options.serverTimeDiff)) {
      hasCaculatedMap[featureIdStr] = false;
      return {
        toggleValue: false
      };
    } // judge prerequisite


    if (feature.prerequisites && !judgePrerequisite(feature, context, hasCaculatedMap)) {
      if (hasDataset === WithDataset) {
        var _result = getDatasetFromStrategyGroup(context, feature.offDatasetEx);

        _result.toggleValue = false;
        return _result;
      }

      return {
        toggleValue: false
      };
    } // 2.get toggle value and variations from strategy groups


    var result = getToggleValueAndDatasetFromStrategyGruops(feature, context, hasCaculatedMap, hasDataset);
    return result;
  }

  function judgePrerequisite(feature, context, hasCaculatedMap) {
    var featureIdStr = feature.id.toString();

    var _iterator6 = _createForOfIteratorHelper(feature.prerequisites),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var prerequisite = _step6.value;
        var id = prerequisite.versionId.toString();
        var result = isEnabledCalculator(cachedData.prerequisite[id], context, hasCaculatedMap);
        var statusValue = prerequisite.statusValue === FEATURE_VALUE_STR_TRUE ? true : false;

        if (result.toggleValue !== statusValue) {
          hasCaculatedMap[featureIdStr] = false;
          return false;
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    return true;
  }

  function getToggleValueAndDatasetFromStrategyGruops(feature, context, hasCaculatedMap, hasDataset) {
    if (feature.strategyGroups && feature.strategyGroups.length > 0) {
      for (var i = 0; i < feature.strategyGroups.length; i++) {
        var strategyGroup = feature.strategyGroups[i];

        if (judgeStrategy(feature.id, strategyGroup, context, feature.name, hasCaculatedMap)) {
          var datasetEx = strategyGroup.datasetEx;

          if (hasDataset === WithDataset) {
            var result = getDatasetFromStrategyGroup(context, datasetEx);
            result.toggleValue = datasetEx.toggleValue;
            return result;
          } else {
            if (!datasetEx || datasetEx && datasetEx.toggleValue === undefined) {
              return {
                toggleValue: true
              };
            }

            return {
              toggleValue: datasetEx.toggleValue
            };
          }
        }
      }
    } // 未命中策略, 返回false, 以及根据hasDataset返回配置


    if (hasDataset === WithDataset) {
      var _result2 = getDatasetFromStrategyGroup(context, feature.defaultDatasetEx);

      _result2.toggleValue = false;
      return _result2;
    } else {
      return {
        toggleValue: false
      };
    }
  }

  function judgeStrategy(featureId, strategyGroup, context, featureName, hasCaculatedMap, groupOrder) {
    var featureIdStr = featureId.toString();
    var strategies = strategyGroup.strategies;

    if (strategies && strategies.length === 0) {
      hasCaculatedMap[featureIdStr] = true;
      return true;
    }

    var isStgRelationAnd = strategyGroup.stgRelation === STG_RELATION_AND;

    var _iterator7 = _createForOfIteratorHelper(strategies),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var fStrategy = _step7.value;
        var strategy = getStrategy(fStrategy.name || '');

        if (!strategy) {
          emitter.maybeReportError(new ToggleBadFeatureError(missingStrategyError(fStrategy.name, featureName)));

          if (isStgRelationAnd) {
            hasCaculatedMap[featureIdStr] = false;
            return false;
          }

          continue;
        }

        var stgRes = strategy.isEnabled(fStrategy.parameters, context || {}); // and关系有一个false，返回false

        if (isStgRelationAnd && !stgRes) {
          hasCaculatedMap[featureIdStr] = false;
          return false;
        } // 默认按照or处理，有一个true，返回true


        if (!isStgRelationAnd && stgRes) {
          hasCaculatedMap[featureIdStr] = true;
          return true;
        }
      } // 要不and关系全部为true，返回true; 要不or关系全部为false，返回false

    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    hasCaculatedMap[featureIdStr] = isStgRelationAnd;
    return isStgRelationAnd;
  }

  function getDatasetFromStrategyGroup(context, datasetEx) {
    if (_typeof(datasetEx) !== 'object' || datasetEx === null) {
      return {
        dataset: {},
        datasetId: 0,
        versionId: 0,
        type: '',
        value: ''
      };
    }

    if (datasetEx.datasetType === DatasetTypePrecise) {
      // 精确匹配
      return getDatasetResult(datasetEx.dataset);
    }

    if (datasetEx.datasetType === DatasetTypePercentage) {
      // 百分比匹配
      // 1.获取百分比值
      var percent = 0;
      var rolloutBase = datasetEx.rolloutBase;

      if (context && context[rolloutBase]) {
        // 取context中的rollouBase
        if (typeof context[rolloutBase] === 'string') {
          var temp = context[rolloutBase];
          percent = getHashPercentNumber(temp);
        } else {
          // 非string类型,使用纯随机数
          percent = getRandomPercentNumber();
        }
      } else if (context && context.properties && context.properties[rolloutBase]) {
        // 取context.properties中的rollouBase
        percent = getHashPercentNumber(context.properties[rolloutBase]);
      } else {
        // 使用纯随机数
        percent = getRandomPercentNumber();
      } // 2.根据百分比值查找对应的data


      var currentPercent = 0;

      if (datasetEx.rolloutWeights === null) {
        return {
          dataset: {},
          datasetId: 0,
          versionId: 0,
          type: '',
          value: ''
        };
      }

      var _iterator8 = _createForOfIteratorHelper(datasetEx.rolloutWeights),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var rolloutWeight = _step8.value;
          currentPercent += rolloutWeight.weight; // percent小于当前rolloutWeight.weight之和, 则命中, 返回data

          if (percent <= currentPercent) {
            return getDatasetResult(rolloutWeight);
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }

    return {
      dataset: {},
      datasetId: 0,
      versionId: 0,
      type: '',
      value: ''
    };
  }

  function getDatasetResult(dataset) {
    if (!dataset) {
      return {
        dataset: {},
        datasetId: 0,
        versionId: 0,
        type: '',
        value: ''
      };
    }

    return {
      dataset: dataset.data || {},
      datasetId: dataset.datasetId || 0,
      versionId: dataset.versionId || 0,
      type: dataset.type || '',
      value: dataset.value || ''
    };
  }

  function featureHttpRequest(canRetry, needUpdateHeader) {
    var endpoint = "".concat(accessDomain, "/").concat(setName, "/").concat(fetchSuffix);
    var method = 'POST';
    var localIds = getLocalIdList();
    var data = {
      productId: options.productId,
      moduleId: options.moduleId,
      moduleVersion: options.version,
      timestamp: lastUpdateTimeStamp,
      localIdList: localIds,
      clientCtx: options.context
    };
    var JSONData = JSON.stringify(data);
    var headers = getHeaderWithJwt(options.productKey, options.productEn, options.serverTimeDiff);

    if (needUpdateHeader) {
      headers = getHeaderWithJwt(options.productKey, options.productEn, options.serverTimeDiff);
    }

    var req = platform.httpRequest(method, endpoint, headers, JSONData);
    var p = req.promise.then(function (featureRes) {
      if (!featureRes) {
        return;
      }

      if (featureRes.status === HTTP_UNAUTHORIZED_CODE && canRetry > 1) {
        // Configure server time difference then retry
        var respData = JSON.parse(featureRes.body);
        var shouldRetry = options.configureServerTimeDiffFromMsg(respData.msg);

        if (shouldRetry) {
          return featureHttpRequest(canRetry - 1, true);
        }
      } else if (featureRes.status >= HTTP_SERVER_ERROR_CODE && canRetry > 1) {
        return featureHttpRequest(canRetry - 1);
      } else if (featureRes.status === HTTP_NOT_FOUND_CODE) {
        // product not available in current set, need to re-configure
        return getSetConfig();
      } else if (featureRes.status === HTTP_OK_CODE) {
        var _respData = JSON.parse(featureRes.body);

        if (_respData.code === SET_MIGRATION_CODE && _respData.setName) {
          var accessSet = JSON.parse(_respData.setName);
          setName = accessSet.TafSet;
          return fetch();
        }

        if (_respData.nextTime && _respData.nextTime > 0) {
          refreshInterval = _respData.nextTime * 1000;
        }

        setFeatures(_respData);
        onNextTick(function () {
          emitter.emit(fetchEvent, _respData.data);
        });

        if (!inited) {
          logger.debug(debugInitWithFetch());
          inited = true;
          onNextTick(function () {
            emitter.emit(readyEvent);
          });
        }
      } else {
        onNextTick(function () {
          return emitter.maybeReportError(getResponseError(featureRes, errorType[0]));
        });
      }
    }).catch(function (err) {
      if (canRetry > 1) {
        return featureHttpRequest(canRetry - 1);
      }

      onNextTick(function () {
        emitter.maybeReportError(err);
      });
    });
    return p;
  }

  function productHttpRequest(canRetry, needUpdateHeader) {
    var endpoint = "".concat(accessDomain, "/").concat(configSuffix);
    var method = 'POST';
    var data = {
      productId: options.productId
    };
    var JSONData = JSON.stringify(data);
    var headers = getHeaderWithJwt(options.productKey, options.productEn, options.serverTimeDiff);

    if (needUpdateHeader) {
      headers = getHeaderWithJwt(options.productKey, options.productEn, options.serverTimeDiff);
    }

    var req = platform.httpRequest(method, endpoint, headers, JSONData);
    var p = req.promise.then(function (productRes) {
      if (!productRes) {
        return;
      }

      if (productRes.status === HTTP_UNAUTHORIZED_CODE && canRetry > 1) {
        // Configure server & client time difference then retry
        var respData = JSON.parse(productRes.body);
        var shouldRetry = options.configureServerTimeDiffFromMsg(respData.msg);

        if (shouldRetry) {
          return productHttpRequest(canRetry - 1, true);
        }
      } else if (productRes.status >= HTTP_SERVER_ERROR_CODE && canRetry > 1) {
        // Retry on 5xx response
        return productHttpRequest(canRetry - 1);
      } else if (productRes.status === HTTP_OK_CODE) {
        var _respData2 = JSON.parse(productRes.body);

        if (_respData2.data && _respData2.data.setName) {
          if (setName === _respData2.data.setName) {
            return;
          }

          setName = _respData2.data.setName;
          return fetch();
        }
      } else {
        onNextTick(function () {
          emitter.maybeReportError(getResponseError(productRes, errorType[1]));
        });
      }
    }).catch(function (err) {
      // Retry on network error.
      if (canRetry > 1) {
        return productHttpRequest(canRetry - 1);
      }

      onNextTick(function () {
        emitter.maybeReportError(err);
      });
    });
    return p;
  }

  function reportHttpRequest(canRetry, params) {
    var data = '';
    var method = 'POST';
    var url = 'https://h.trace.qq.com/kv';
    var header = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    Object.keys(params).map(function (item) {
      data += "".concat(item, "=").concat(params[item], "&");
    });
    data += "_dc=".concat(+Math.random());
    var req = platform.httpRequest(method, url, header, data);
    var p = req.promise.then(function (result) {
      if (!result) {
        return false;
      }

      if (result.status === HTTP_OK_CODE) {
        return true;
      } else if (canRetry > 1) {
        // Retry
        return reportHttpRequest(canRetry - 1, params);
      } else {
        onNextTick(function () {
          emitter.emit('warn', 'report error,please retry');
        });
      }
    }).catch(function (err) {
      onNextTick(function () {
        emitter.emit('warn', 'report error');
      });

      if (canRetry > 1) {
        return reportHttpRequest(canRetry - 1, params);
      }

      onNextTick(function () {
        emitter.maybeReportError(err);
      });
    });
    return p;
  }

  function commonIsEnabled(key, context, fallback, abTestInfo, hasDataset) {
    var feature;
    var abTestId = '-1';
    var result = {};

    if (!inited) {
      result.toggleValue = uninitedIsEnabled(key, fallback);
    } else {
      feature = cachedData.featureData[key];

      if (!feature) {
        // if feature not exist, try valid abTestInfo, then fallback
        result = getAbTestInfoValueAndDataset(abTestInfo, key) || {};

        if (result.toggleValue) {
          abTestId = abTestInfo.abTestId;
        } else {
          result.toggleValue = fallback && typeof fallback === 'boolean' ? fallback : false;
        }
      } else {
        var returnData;

        if (cloudMode === true) {
          returnData = judgeHasFeatureForCloudMode(feature, key, fallback, abTestInfo, hasDataset, options);
        } else {
          returnData = judgeHasFeature(feature, key, context, fallback, abTestInfo, hasDataset, options);
        }

        result = returnData.result;
        abTestId = returnData.abTestId;
      }
    }

    var e = feature ? _objectSpread2(_objectSpread2({}, feature), {}, {
      enabledResult: result
    }) : {
      id: -1,
      name: key,
      enabledResult: result
    };
    emitter.emit(triggerEvent, e);

    if (enqueueEvent) {
      if (context && context.userId) {
        e.userId = context.userId;
      }

      if (context && context.sessionId) {
        e.sessionId = context.sessionId;
      }

      e.abTestId = abTestId;
      enqueueEvent(e);
    }

    return result;
  }

  function judgeHasFeature(feature, key, context, fallback, abTestInfo, hasDataset, options) {
    var result = {};
    var abTestId = '-1'; // if feature exist

    result = getAbTestInfoValueAndDataset(abTestInfo, key) || {}; // 1. use a/b test config if isAbtFirst set to true

    if (feature.isAbtFirst && !!result.toggleValue) {
      abTestId = abTestInfo.abTestId;
      return {
        result: result,
        abTestId: abTestId
      };
    } // 2. use off dataset if feature is closed


    if (feature.value !== FEATURE_VALUE_STR_TRUE) {
      if (hasDataset === WithDataset) {
        result = getDatasetFromStrategyGroup(context, feature.offDatasetEx);
      }

      result.toggleValue = false;
      return {
        result: result,
        abTestId: abTestId
      };
    } // 3. check if there is a time limit restricted


    if (!checkTimeLimitsMatch(feature.timeLimitType, feature.timeLimits, options.serverTimeDiff)) {
      if (hasDataset === WithDataset) {
        result = getDatasetFromStrategyGroup(context, feature.offDatasetEx);
      }

      result.toggleValue = typeof fallback === 'boolean' ? fallback : false;
      return {
        result: result,
        abTestId: abTestId
      };
    } // 4. default mode


    var hasCaculatedMap = {};
    result = isEnabledCalculator(feature, context, hasCaculatedMap, hasDataset);
    return {
      result: result,
      abTestId: abTestId
    };
  }

  function judgeHasFeatureForCloudMode(feature, key, fallback, abTestInfo, hasDataset, options) {
    var result = {};
    var abTestId = '-1'; // if feature exist

    result = getAbTestInfoValueAndDataset(abTestInfo, key) || {}; // 1. use a/b test config if isAbtFirst set to true

    if (feature.isAbtFirst && !!result.toggleValue) {
      abTestId = abTestInfo.abTestId;
      return {
        result: result,
        abTestId: abTestId
      };
    } // 2. check if there is a time limit restricted


    if (!checkTimeLimitsMatch(feature.timeLimitType, feature.timeLimits, options.serverTimeDiff)) {
      if (hasDataset === WithDataset) {
        result = {
          dataset: {},
          datasetId: 0,
          versionId: 0
        };
      }

      result.toggleValue = typeof fallback === 'boolean' ? fallback : false;
      return {
        result: result,
        abTestId: abTestId
      };
    } // 3. default mode


    if (hasDataset === WithDataset) {
      var _feature$dataset, _feature$dataset2, _feature$dataset3, _feature$dataset4, _feature$dataset5;

      result = {
        dataset: ((_feature$dataset = feature.dataset) === null || _feature$dataset === void 0 ? void 0 : _feature$dataset.data) || {},
        datasetId: ((_feature$dataset2 = feature.dataset) === null || _feature$dataset2 === void 0 ? void 0 : _feature$dataset2.datasetId) || 0,
        versionId: ((_feature$dataset3 = feature.dataset) === null || _feature$dataset3 === void 0 ? void 0 : _feature$dataset3.versionId) || 0,
        type: ((_feature$dataset4 = feature.dataset) === null || _feature$dataset4 === void 0 ? void 0 : _feature$dataset4.type) || '',
        value: ((_feature$dataset5 = feature.dataset) === null || _feature$dataset5 === void 0 ? void 0 : _feature$dataset5.value) || ''
      };
    }

    result.toggleValue = feature.result === FEATURE_VALUE_STR_TRUE ? true : false;
    return {
      result: result,
      abTestId: abTestId
    };
  }

  repository.getTimestamp = function () {
    return lastUpdateTimeStamp;
  };

  repository.getSetName = function () {
    return setName;
  };

  repository.getrefreshInterval = function () {
    return refreshInterval;
  };

  repository.readyPromise = function () {
    return new Promise(function (resolve, reject) {
      var resolveHandler = function resolveHandler() {
        resolve();
      };

      var rejectHandler = function rejectHandler(error) {
        reject(error);
      };

      emitter.on(readyEvent, resolveHandler);
      emitter.on(errorEvent, rejectHandler);
    });
  };

  repository.fetch = function () {
    return fetch();
  };

  repository.isEnabled = function (key, context, fallback, abTestInfo) {
    var result = commonIsEnabled(key, context, fallback, abTestInfo, WithoutDataset);
    return result.toggleValue;
  };

  repository.isEnabledWithDataset = function (name, context, fallbackValue, abTestInfo) {
    var result = commonIsEnabled(name, context || {}, fallbackValue, abTestInfo, WithDataset);
    var returnVal = {
      toggleValue: result.toggleValue,
      dataset: ''
    };

    switch (result.type) {
      case DataTypeMap:
        returnVal.dataset = result.dataset;
        break;

      case DataTypeString:
      case DataTypeJSON:
        returnVal.dataset = result.value;
        break;

      case DataTypeBool:
        returnVal.dataset = result.value === 'true';
        break;

      case (DataTypeFloat):
        returnVal.dataset = Number(result.value);
        break;

      case DataTypeList:
        try {
          var listStr = JSON.parse(result.value).filter(function (s) {
            return s;
          });
          returnVal.dataset = listStr;
        } catch (error) {
          emitter.emit('warn', "toggle ".concat(name, " get list data error, using default value: ").concat(error));
          returnVal.dataset = [];
        }

        break;

      default:
        returnVal.dataset = '';
    }

    return returnVal;
  };

  repository.syncLoadFeatures = function () {
    var storedFeatures = storage.syncLoadFeatures();

    if (storedFeatures) {
      cachedData = storedFeatures;

      if (!inited) {
        inited = true;
        onNextTick(function () {
          return emitter.emit(readyEvent);
        });
      }
    }
  };

  repository.getFeature = function (name) {
    var feature = cachedData.featureData[name];

    if (feature) {
      return Object.assign({}, feature);
    }

    return null;
  };

  repository.getAllFeatures = function () {
    return Object.assign({}, cachedData.featureData);
  };

  var fetchTick = function fetchTick() {
    repository.fetch();
    fetchTimer = setTimeout(fetchTick, refreshInterval);
  };

  repository.start = function () {
    finishInit();

    if (closed) {
      return;
    }

    fetchTimer = setTimeout(fetchTick, refreshInterval);
  };

  repository.stop = function () {
    closed = true;
    clearTimeout(fetchTimer);
    cachedData = {
      featureData: {},
      prerequisite: {}
    };
  };

  repository.activateExperiment = function (data) {
    if (_typeof(data) !== 'object' || data === null) {
      return null;
    }

    var guid = data.guid,
        expData = data.expData,
        appid = data.appid;
    tabCache.guid = guid;
    tabCache.appid = appid;

    if (_typeof(expData) === 'object' && expData !== null) {
      tabCache.tabInfo = expData;
    } else {
      return false;
    }

    return true;
  };

  repository.reportTabMetricsData = function (tabReportData) {
    if (!tabReportData) {
      onNextTick(function () {
        emitter.emit('warn', 'tabReportData undefined');
      });
      return false;
    } // get exp info


    var info = tabCache.tabInfo[tabReportData.expId];

    if (!info) {
      onNextTick(function () {
        emitter.emit('warn', "no such exp info which id is ".concat(tabReportData.expId));
      });
      return false;
    }

    var featureName = info.params && info.params[TabToggleNameField];

    if (!featureName) {
      onNextTick(function () {
        emitter.emit('warn', "params of exp has no attribute named ".concat(TabToggleNameField));
      });
      return info.params;
    }

    var feature = cachedData.featureData[featureName]; // require key

    if (!feature || !tabCache.appid || !tabCache.guid || !feature.id || !tabReportData.expId || !options.productId || !info.grayId) {
      onNextTick(function () {
        emitter.emit('warn', "the following attributes can't be undefined. \n        feature productId:".concat(options.productId, "; feature id:").concat(feature && feature.id, "; \n        app id:").concat(tabCache && tabCache.appid, "; guid:").concat(tabCache && tabCache.guid, ";\n        gray id:").concat(info.grayId, ";\n        exp id:").concat(tabReportData && tabReportData.expId));
      });
      return false;
    }

    var serverTime = Math.round(getAdjustedShanghaiTime().valueOf() / 1000);
    var params = {
      attaid: '03d00037385',
      token: '3868159371',
      uin: tabCache.guid,
      business_id: options.productId,
      tab_business_id: tabCache.appid,
      feature_id: feature.id.toString(),
      feature_name: featureName,
      feature_percentage: info.percentage,
      event_time: serverTime,
      report_time: serverTime,
      exp_id: tabReportData.expId,
      event_code: tabReportData.eventCode || '',
      event_value: tabReportData.eventValue || '',
      reserved: tabReportData.reserved || '',
      gray_id: info.grayId
    };

    if (_typeof(tabReportData.reserved) === 'object' && tabReportData.reserved !== null) {
      var reserved = tabReportData.reserved;
      var data = '';
      Object.keys(reserved).map(function (item) {
        data += "".concat(item, "=").concat(reserved[item], "&");
      });
      params.reserved = encodeURIComponent(data);
    }

    reportHttpRequest(MAX_HTTP_RETRY, params);
    return true;
  };

  repository.setCloudModeContext = function (context) {
    options.context = context || {};
    lastUpdateTimeStamp = TimeStampNeedFullUpdate;

    if (inited) {
      repository.fetch();
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(fetchTick, refreshInterval);
    }
  };

  repository.asyncSetCloudModeContext = function (context) {
    options.context = context || {};
    lastUpdateTimeStamp = TimeStampNeedFullUpdate;

    if (inited) {
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(fetchTick, refreshInterval);
      return repository.fetch;
    }
  };

  return repository;
}

function MetricsSender(platform, options) {
  var sender = {};
  var postUrl = "".concat(options.statsDomain, "/report/feature-trigger-event-json");
  var productKey = options.productKey;
  var productEn = options.productEn;

  function getResponseInfo(result) {
    var ret = {
      status: result.status
    };
    return ret;
  }

  sender.sendMetrics = function (events) {
    if (!platform.httpRequest) {
      return Promise.resolve();
    }

    var method = 'POST';
    var JSONData = JSON.stringify(events);
    var headers = getHeaderWithJwt(productKey, productEn, options.serverTimeDiff);

    function doPostRequest(canRetry, needUpdateHeader) {
      if (needUpdateHeader) {
        headers = getHeaderWithJwt(productKey, productEn, options.serverTimeDiff);
      }

      var req = platform.httpRequest(method, postUrl, headers, JSONData);
      var p = req.promise.then(function (result) {
        // This was a response from a fire-and-forget request, so no status.
        if (!result) {
          return;
        }

        if (result.status === HTTP_UNAUTHORIZED_CODE && canRetry > 1) {
          // Configure server & client time difference then retry
          var respData = JSON.parse(result.body);
          var shouldRetry = options.configureServerTimeDiffFromMsg(respData.msg);

          if (shouldRetry) {
            return doPostRequest(canRetry - 1, true);
          }
        } else if (result.status >= HTTP_SERVER_ERROR_CODE && canRetry > 1) {
          return doPostRequest(canRetry - 1);
        } else {
          return getResponseInfo(result);
        }
      }).catch(function () {
        if (canRetry > 1) {
          return doPostRequest(canRetry - 1);
        }
      });
      return p;
    }

    var canPost = platform.httpAllowsPost();
    return canPost ? doPostRequest(MAX_HTTP_RETRY) : Promise.resolve();
  };

  return sender;
}

var sentEvent = 'sent';
function MetricsProcessor(platform, options) {
  var emitter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var processor = {};
  var eventSender = sender || MetricsSender(platform, options);
  var disableMetrics = options.disableMetrics;
  var metricsInterval = options.metricsInterval;
  var logger = options.logger;
  var queue = createNewQueue();
  var flushTimer; // in case close() run before start()

  var closed;
  var osPlatform = '';

  if (platform.getOsPlatform) {
    osPlatform = platform.getOsPlatform();
  }

  function createNewQueue() {
    var ret = {
      sdkType: 'JavaScript',
      sdkVersion: "1.10.7",
      startTime: formatDate(new Date()),
      stopTime: '',
      productId: options.productId,
      moduleId: options.moduleId,
      moduleVersion: options.version,
      eventsMap: new Map(),
      os: osPlatform
    };
    return ret;
  }

  function makeOutputEvent(e) {
    var eventKey = {
      featureName: e.name || 'undefined',
      featureVersionId: String(e.id) || '-1',
      featureValue: e.enabledResult.toggleValue ? 'true' : 'false',
      abTestId: e.abTestId,
      userId: '',
      datasetId: e.enabledResult.datasetId ? String(e.enabledResult.datasetId) : '0',
      versionId: e.enabledResult.versionId ? String(e.enabledResult.versionId) : '0'
    };

    if (e.userId) {
      eventKey.userId = e.userId;
    }

    return stringfyEvent(eventKey);
  }

  function hasSameEvent(eventKey) {
    if (queue.eventsMap.has(eventKey)) {
      var eventCount = queue.eventsMap.get(eventKey) + 1;
      queue.eventsMap.set(eventKey, eventCount);
      return true;
    }

    return false;
  }

  function stringfyEvent(event) {
    return "".concat(event.featureName, "#").concat(event.featureVersionId, "#").concat(event.featureValue, "#").concat(event.abTestId, "#").concat(event.userId, "#").concat(event.datasetId, "#").concat(event.versionId);
  }

  function parseEventString(key) {
    var event = key.split('#');
    var eventKey = {
      featureName: event[0],
      featureVersionId: event[1],
      featureValue: event[2],
      abTestId: event[3],
      userId: event[4],
      datasetId: event[5],
      versionId: event[6]
    };
    return eventKey;
  }

  function eventsMap2list() {
    var event;
    queue.events = [];
    queue.eventsMap.forEach(function (value, key) {
      event = parseEventString(key);
      event.eventCount = value;
      event.sn = v4_1();
      queue.events.push(event);
    });
    queue.eventsMap = new Map();
  }

  processor.enqueue = function (event) {
    if (disableMetrics) {
      return;
    }

    var eventKey = makeOutputEvent(event);

    if (!hasSameEvent(eventKey)) {
      queue.eventsMap.set(eventKey, 1);
    }
  };

  processor.flush = function () {
    if (disableMetrics) {
      return Promise.resolve();
    }

    queue.stopTime = formatDate(new Date());
    eventsMap2list();
    var eventsToSend = queue;

    if (eventsToSend.events.length === 0) {
      queue.eventsMap = new Map();
      return Promise.resolve();
    }

    queue = createNewQueue();
    logger.debug(debugPositionEvents(eventsToSend.length));
    return eventSender.sendMetrics(eventsToSend).then(function (responseInfo) {
      if (responseInfo) {
        if (responseInfo.status !== 200) {
          onNextTick(function () {
            emitter.maybeReportError(new ToggleUnexpectedResponseError(httpErrorMessage(responseInfo.status, 'send metrics')));
          });
        } else {
          emitter.emit(sentEvent, eventsToSend);
        }
      }
    });
  };

  processor.start = function () {
    if (closed) {
      return;
    }

    var flushTick = function flushTick() {
      processor.flush();
      flushTimer = setTimeout(flushTick, metricsInterval);
    };

    flushTimer = setTimeout(flushTick, metricsInterval);
  };

  processor.stop = function () {
    closed = true;
    clearTimeout(flushTimer);
  };

  return processor;
}

function DefaultStrategy() {
  var strategy = {};
  strategy.name = 'default';

  strategy.isEnabled = function () {
    return true;
  };

  return strategy;
}

/**
 * This strategy should basically not be used in a client sdk, because a web client does not have a host name.
 */
function ApplicationHostnameStrategy() {
  var strategy = {};
  var hostname = 'undefined';
  strategy.name = 'applicationHostname';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var listType = '';

    if (parameters.listType && typeof JSON.parse(parameters.listType) === 'string') {
      listType = JSON.parse(parameters.listType);
    }

    if (listType === 'blacklist') {
      if (!parameters.hostNames) {
        return true;
      }

      return !JSON.parse(parameters.hostNames).toLowerCase().split(/\s*,\s*/).includes(hostname);
    } // 默认白名单处理


    if (!parameters.hostNames) {
      return false;
    }

    return JSON.parse(parameters.hostNames).toLowerCase().split(/\s*,\s*/).filter(function (s) {
      return s;
    }).includes(hostname);
  };

  return strategy;
}

function GradualRolloutRandomStrategy(rg) {
  var strategy = {};

  var randomGenerator = rg || function () {
    return Math.floor(Math.random() * 100) + 1;
  };

  strategy.name = 'gradualRolloutRandom';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var percentage = 0;

    try {
      percentage = Number(JSON.parse(parameters.percentage));

      if (percentage >= 100) {
        return true;
      }
    } catch (error) {
      return false;
    }

    var random = randomGenerator();
    return percentage >= random;
  };

  return strategy;
}

function normalizedValue(id, groupId) {
  var normalizer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  return murmurhash3js.x86.hash32("".concat(groupId, ":").concat(id)) % normalizer + 1;
}
function V6Format(ip) {
  if (/(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/.test(ip)) {
    return true;
  }

  return false;
}

function ip2long(ip) {
  var components = ip.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);

  if (components) {
    var iplong = 0;
    var power = 1;

    for (var i = 4; i >= 1; i -= 1) {
      iplong += power * parseInt(components[i]);
      power *= 256;
    }

    return iplong;
  }

  return -1;
}

function inSubNet(ip, subnet) {
  var mask = subnet.match(/^(.*?)\/(\d{1,2})$/);
  var baseIp = mask ? ip2long(mask[1]) : -1;
  var longIp = ip2long(ip);

  if (mask && baseIp >= 0) {
    var freedom = Math.pow(2, 32 - parseInt(mask[2]));
    return longIp > baseIp && longIp < baseIp + freedom - 1;
  }

  return false;
}

function GradualRolloutUserIdStrategy() {
  var strategy = {};
  strategy.name = 'gradualRolloutUserId';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var percentage = 0;

    try {
      percentage = Number(JSON.parse(parameters.percentage));

      if (percentage >= 100) {
        return true;
      }
    } catch (error) {
      return false;
    }

    var userId = context.userId;

    if (!userId) {
      return false;
    }

    var groupId = JSON.parse(parameters.groupId) || '';
    var normalizedUserId = normalizedValue(userId, groupId);
    return percentage > 0 && normalizedUserId <= percentage;
  };

  return strategy;
}

function GradualRolloutSessionIdStrategy() {
  var strategy = {};
  strategy.name = 'gradualRolloutSessionId';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var percentage = 0;

    try {
      percentage = Number(JSON.parse(parameters.percentage));

      if (percentage >= 100) {
        return true;
      }
    } catch (error) {
      return false;
    }

    var sessionId = context.sessionId;

    if (!sessionId) {
      return false;
    }

    var groupId = JSON.parse(parameters.groupId) || '';
    var normalizedId = normalizedValue(sessionId, groupId);
    return percentage > 0 && normalizedId <= percentage;
  };

  return strategy;
}

function UserWithIdStrategy() {
  var strategy = {};
  strategy.name = 'userWithId';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var listType = '';

    if (parameters.listType && typeof JSON.parse(parameters.listType) === 'string') {
      listType = JSON.parse(parameters.listType);
    }

    if (listType === 'blacklist') {
      if (!parameters.userIds || !context.userId) {
        return true;
      }

      var _userIdList = JSON.parse(parameters.userIds).split(/\s*,\s*/).filter(function (s) {
        return s;
      });

      return !_userIdList.includes(context.userId);
    } // 默认白名单处理


    if (!parameters.userIds || !context.userId) {
      return false;
    }

    var userIdList = JSON.parse(parameters.userIds).split(/\s*,\s*/).filter(function (s) {
      return s;
    });
    return userIdList.includes(context.userId);
  };

  return strategy;
}

function RemoteAddressStrategy() {
  var strategy = {};
  strategy.name = 'remoteAddress';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var listType = '';

    if (parameters.listType && typeof JSON.parse(parameters.listType) === 'string') {
      listType = JSON.parse(parameters.listType);
    }

    if (listType === 'blacklist') {
      if (!parameters.IPs || !context.remoteAddress) {
        return true;
      }

      var _iterator = _createForOfIteratorHelper(JSON.parse(parameters.IPs).split(/\s*,\s*/).filter(function (s) {
        return s;
      })),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var range = _step.value;

          try {
            if (range === context.remoteAddress) {
              return false;
            } else if (!V6Format(range)) {
              if (inSubNet(context.remoteAddress, range)) {
                return false;
              }
            }
          } catch (e) {
            continue;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    } // 默认白名单处理


    if (!parameters.IPs || !context.remoteAddress) {
      return false;
    }

    var _iterator2 = _createForOfIteratorHelper(JSON.parse(parameters.IPs).split(/\s*,\s*/).filter(function (s) {
      return s;
    })),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _range = _step2.value;

        try {
          if (_range === context.remoteAddress) {
            return true;
          } else if (!V6Format(_range)) {
            if (inSubNet(context.remoteAddress, _range)) {
              return true;
            }
          }
        } catch (e) {
          continue;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return false;
  };

  return strategy;
}

var QimeiStrategy = function QimeiStrategy() {
  var strategy = {};
  strategy.name = 'qimei';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var listType = '';

    if (parameters.listType && typeof JSON.parse(parameters.listType) === 'string') {
      listType = JSON.parse(parameters.listType);
    }

    if (listType === 'blacklist') {
      if (!parameters.qimeis || !context.qimei) {
        return true;
      }

      var _qimeiList = JSON.parse(parameters.qimeis).split(/\s*,\s*/).filter(function (s) {
        return s;
      });

      return !_qimeiList.includes(context.qimei);
    } // 默认白名单处理


    if (!parameters.qimeis || !context.qimei) {
      return false;
    }

    var qimeiList = JSON.parse(parameters.qimeis).split(/\s*,\s*/).filter(function (s) {
      return s;
    });
    return qimeiList.includes(context.qimei);
  };

  return strategy;
};

function UserIdTailNumberStrategy() {
  var strategy = {};
  strategy.name = 'userIdTailNumber';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var listType = '';

    if (parameters.listType && typeof JSON.parse(parameters.listType) === 'string') {
      listType = JSON.parse(parameters.listType);
    }

    if (listType === 'blacklist') {
      if (!parameters.userIdTailNum || !context.userId) {
        return true;
      }

      var _userIdTailNumList = JSON.parse(parameters.userIdTailNum).split(/\s*,\s*/).filter(function (s) {
        return s;
      });

      var _iterator = _createForOfIteratorHelper(_userIdTailNumList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var userIdTailNum = _step.value;

          if (context.userId.endsWith(userIdTailNum)) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    } // 默认白名单处理


    if (!parameters.userIdTailNum || !context.userId) {
      return false;
    }

    var userIdTailNumList = JSON.parse(parameters.userIdTailNum).split(/\s*,\s*/).filter(function (s) {
      return s;
    });

    var _iterator2 = _createForOfIteratorHelper(userIdTailNumList),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _userIdTailNum = _step2.value;

        if (context.userId.endsWith(_userIdTailNum)) {
          return true;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return false;
  };

  return strategy;
}

function CustomKVPropertyStrategy() {
  var strategy = {};
  strategy.name = 'customKVProperty';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var listType = WHITE_LIST;

    if (parameters.listType && typeof JSON.parse(parameters.listType) === 'string') {
      if (JSON.parse(parameters.listType) === BLACK_LIST) {
        listType = BLACK_LIST;
      }
    }

    var matchType = MATCH_TYPE_EQUAL;

    if (parameters.matchType && typeof JSON.parse(parameters.matchType) === 'string') {
      if (JSON.parse(parameters.matchType) === MATCH_TYPE_REG) {
        matchType = MATCH_TYPE_REG;
      }
    }

    if (!parameters.propertyMap) {
      return listType === BLACK_LIST;
    }

    var propertyMapStr = JSON.parse(parameters.propertyMap);
    var propertyMap = JSON.parse(propertyMapStr);

    if (!context.properties) {
      return listType === BLACK_LIST;
    }

    for (var propertyKey in propertyMap) {
      if (!context.properties[propertyKey]) {
        return listType === BLACK_LIST;
      }

      if (matchPropertyList(propertyMap[propertyKey], context.properties[propertyKey], matchType)) {
        continue;
      } // context properties no match


      return listType === BLACK_LIST;
    } // context properties all match


    return listType == WHITE_LIST;
  };

  function matchPropertyList(propertyList, contextValue, matchType) {
    for (var i = 0; i < propertyList.length; i++) {
      if (matchType === MATCH_TYPE_REG) {
        if (contextValue.search(propertyList[i]) >= 0) {
          return true;
        }
      } else {
        if (propertyList[i] === contextValue) {
          return true;
        }
      }
    }
  }

  return strategy;
}

function CustomPropertyStrategy() {
  var strategy = {};
  strategy.name = 'customProperty';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var listType = '';

    if (parameters.listType && typeof JSON.parse(parameters.listType) === 'string') {
      listType = JSON.parse(parameters.listType);
    }

    if (listType === 'blacklist') {
      if (!parameters.propertyName || !parameters.propertyValues) {
        return true;
      }

      var _propertyName = JSON.parse(parameters.propertyName);

      if (!context.properties || !context.properties[_propertyName]) {
        return true;
      }

      var _propertyValue = context.properties[_propertyName];

      var _propertyValues = JSON.parse(parameters.propertyValues).split(/\s*,\s*/).filter(function (s) {
        return s;
      });

      return !_propertyValues.includes(_propertyValue);
    } // 默认白名单处理


    if (!parameters.propertyName || !parameters.propertyValues) {
      return false;
    }

    var propertyName = JSON.parse(parameters.propertyName);

    if (!context.properties || !context.properties[propertyName]) {
      return false;
    }

    var propertyValue = context.properties[propertyName];
    var propertyValues = JSON.parse(parameters.propertyValues).split(/\s*,\s*/).filter(function (s) {
      return s;
    });
    return propertyValues.includes(propertyValue);
  };

  return strategy;
}

function GradualRolloutCustomProperty() {
  var strategy = {};
  strategy.name = 'gradualRolloutCustomProperty';

  strategy.isEnabled = function () {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var percentage = 0;

    try {
      percentage = Number(JSON.parse(parameters.percentage));

      if (percentage >= 100) {
        return true;
      }
    } catch (error) {
      return false;
    }

    if (!parameters.propertyName) {
      return false;
    }

    var propertyName = JSON.parse(parameters.propertyName);

    if (!context.properties || !context.properties[propertyName]) {
      return false;
    }

    var propertyValue = context.properties[propertyName];
    var groupId = JSON.parse(parameters.groupId) || '';
    var normalizedId = normalizedValue(propertyValue, groupId);
    return percentage > 0 && normalizedId <= percentage;
  };

  return strategy;
}

var defaultStrategies = [DefaultStrategy(), ApplicationHostnameStrategy(), GradualRolloutRandomStrategy(), GradualRolloutUserIdStrategy(), GradualRolloutSessionIdStrategy(), UserWithIdStrategy(), RemoteAddressStrategy(), UserIdTailNumberStrategy(), CustomKVPropertyStrategy(), CustomPropertyStrategy(), GradualRolloutCustomProperty(), QimeiStrategy()];

var SERVER_TIME_PREFIX_REF = 'Server time: ';
function validate(env, options, emitter, logger) {
  var baseDefaults = {
    accessDomain: 'https://access.toggle.qq.com',
    statsDomain: 'https://event.toggle.qq.com',
    disableMetrics: false,
    refreshInterval: 2 * 60 * 1000,
    metricsInterval: 2 * 60 * 1000,
    useLocalStorage: true,
    strategies: [],
    // the time difference between server time and client time, used as calibrator for jwt token calculation
    serverTimeDiff: 0,
    encodeCache: false,
    cloudMode: false,
    context: {}
  };
  var defaults = extend({
    logger: logger
  }, baseDefaults);
  var config = extend({}, options || {});
  config = applyDefaults(config, defaults);
  var environments = ['formal', 'dev', 'secure_dev', 'formal_v6'];
  var configDomain = [{
    // formal
    accessDomain: 'https://access.toggle.qq.com',
    statsDomain: 'https://event.toggle.qq.com'
  }, {
    // Dev
    accessDomain: 'https://toggleaccesspre.sparta.html5.qq.com',
    statsDomain: 'https://togglestatdev.sparta.html5.qq.com'
  }, {
    // Secure_dev
    accessDomain: 'https://toggleaccesspre.sparta.html5.qq.com',
    statsDomain: 'https://togglestatdev.sparta.html5.qq.com'
  }, {
    // Formal_v6, support ipv6
    accessDomain: 'https://accessv6.toggle.qq.com',
    statsDomain: 'https://eventv6.toggle.qq.com'
  }]; // if there is an env input

  if (env) {
    var idx = environments.indexOf(env);
    var valueList = [0, 1, 2, 3];

    if (valueList.indexOf(idx) > -1) {
      config.accessDomain = configDomain[idx] && configDomain[idx].accessDomain;
      config.statsDomain = configDomain[idx] && configDomain[idx].statsDomain;
    } else {
      reportArgumentError('Invalid environment configured. Auto set to formal environment.', emitter);
    }
  }

  try {
    config.version = getVersion(config.version);
  } catch (error) {
    reportArgumentError('Invalid product version configured. Must be string with value.', emitter);
  }

  config.invalid = false;
  /**  key值统一处理
  **  key:需要判断的值
  **  message:错误提示
  **  callback:回调函数
  */

  judgeKeyVaild([{
    key: config.buildId,
    message: '',
    callback: function callback() {
      config.version = "".concat(config.version, ".").concat(config.buildId);
    }
  }, {
    key: !config.productKey || typeof config.productKey !== 'string',
    message: 'Invalid product key configured. Must be string with value.',
    callback: function callback() {
      config.invalid = true;
    }
  }, {
    key: !config.productEn || typeof config.productEn !== 'string',
    message: 'Invalid product english name configured. Must be string with value.',
    callback: function callback() {
      config.invalid = true;
    }
  }, {
    key: !config.productId || typeof config.productId !== 'string',
    message: 'Invalid product id configured. Must be string with value.',
    callback: function callback() {
      config.invalid = true;
    }
  }, {
    key: !config.moduleId || typeof config.productEn !== 'string',
    message: 'Invalid product module id configured. Must be string with value.',
    callback: function callback() {
      config.invalid = true;
    }
  }, {
    key: typeof config.disableMetrics !== 'boolean',
    message: 'Invalid disableMetrics configured. Must be boolean value. Auto set to false',
    callback: function callback() {
      config.disableMetrics = false;
    }
  }, {
    key: typeof config.useLocalStorage !== 'boolean',
    message: 'Invalid useLocalStorage configured. Must be boolean value. Auto set to true',
    callback: function callback() {
      config.useLocalStorage = true;
    }
  }, {
    key: typeof config.encodeCache !== 'boolean',
    message: 'Invalid encodeCache configured. Must be boolean value. Auto set to true',
    callback: function callback() {
      config.encodeCache = true;
    }
  }, {
    key: config.buildId && typeof config.version !== 'string',
    message: 'Invalid product buildId configured. Must be string with value.',
    callback: function callback() {
      config.invalid = true;
    }
  }, {
    key: isNaN(config.refreshInterval) || config.refreshInterval < 10 * 1000,
    message: 'Invalid fetch interval configured. Must be an integer >= 1000 (millisecond). Auto set to  120000.',
    callback: function callback() {
      config.refreshInterval = 2 * 60 * 1000;
    }
  }, {
    key: isNaN(config.metricsInterval) || config.metricsInterval < 10 * 1000,
    message: 'Initialization failed with invalid configurations.',
    callback: function callback() {
      config.metricsInterval = 2 * 60 * 1000;
    }
  }, {
    key: !Array.isArray(config.strategies),
    message: 'Invalid custom strategies. Must be objects with fileds name and isEnabled',
    callback: function callback() {
      config.invalid = true;
    }
  }, {
    key: Array.isArray(config.strategies),
    message: '',
    callback: function callback() {
      var _iterator = _createForOfIteratorHelper(config.strategies),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var strategy = _step.value;
          judgeKeyVaild([{
            key: !strategy || !strategy.name || typeof strategy.name !== 'string' || !strategy.isEnabled || typeof strategy.isEnabled !== 'function',
            message: 'Invalid custom strategies. Must be objects with fileds name and isEnabled',
            callback: function callback() {
              config.invalid = true;
            }
          }]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      config.strategies = defaultStrategies.concat(config.strategies);
    }
  }], emitter);

  if (config.invalid) {
    reportArgumentError('Initialization failed with invalid configurations.', emitter);
  }

  config.configureServerTimeDiffFromMsg = function (dataMsg) {
    if (!dataMsg || !dataMsg.includes(SERVER_TIME_PREFIX_REF)) {
      return false;
    }

    var lastIdx = dataMsg.lastIndexOf(SERVER_TIME_PREFIX_REF);
    var serverTimestamp = +dataMsg.slice(lastIdx + SERVER_TIME_PREFIX_REF.length, lastIdx + SERVER_TIME_PREFIX_REF.length + 10);
    return config.configureServerTimeDiff(serverTimestamp);
  };

  config.configureServerTimeDiff = function (serverTimestamp) {
    if (!serverTimestamp) {
      return false;
    }

    var clientTimestamp = Math.floor(new Date() / 1000);
    var diff = serverTimestamp - clientTimestamp;

    if (diff === config.serverTimeDiff) {
      return false;
    } // when calculate jwt tokwn, we use timestamp = currentTimeStamp + serverTimeDiff


    config.serverTimeDiff = diff;
    return true;
  };

  return config;
}

function initialize(env, specifiedOptions, platform) {
  var logger = createLogger();
  var emitter = EventEmitter(logger);
  var options = validate(env, specifiedOptions, emitter, logger);
  var disableMetrics = options.disableMetrics;
  var metrics = MetricsProcessor(platform, options, emitter);
  var repository = Repository(platform, options, enqueueEvent, emitter);
  var closed = false;

  function createLogger() {
    if (specifiedOptions && specifiedOptions.logger) {
      return specifiedOptions.logger;
    }

    return createConsoleLogger('warn');
  }

  function shouldEnqueueEvent() {
    return !disableMetrics && !closed && !platform.isDoNotTrack();
  }

  function enqueueEvent(event) {
    if (shouldEnqueueEvent()) {
      logger.debug(debugEnqueueingEvent());
      metrics.enqueue(event);
    }
  }

  function on(event, handler, context) {
    emitter.on.apply(emitter, arguments);
  }

  function off(event, handler, context) {
    emitter.off.apply(emitter, arguments);
  }

  function start() {
    if (options.invalid) {
      return;
    }

    repository.start();

    if (!disableMetrics) {
      metrics.start();
    }
  }

  function close(onDone) {
    if (closed) {
      return wrapPromiseCallback(Promise.resolve(), onDone);
    }

    var finishClose = function finishClose() {
      closed = true;
    };

    var p = Promise.resolve().then(function () {
      repository.stop();

      if (!disableMetrics) {
        metrics.stop();
        return metrics.flush();
      }
    }).then(finishClose).catch(finishClose);
    return wrapPromiseCallback(p, onDone);
  }

  function loadCachedFeatures() {
    repository.syncLoadFeatures();
  }

  var client = {
    waitUntilReady: function waitUntilReady() {
      return repository.readyPromise();
    },
    isEnabled: repository.isEnabled,
    isEnabledWithDataset: repository.isEnabledWithDataset,
    reportTabMetricsData: repository.reportTabMetricsData,
    activateExperiment: repository.activateExperiment,
    getFeature: function getFeature(name) {
      return repository.getFeature(name);
    },
    getAllFeatures: function getAllFeatures() {
      return repository.getAllFeatures();
    },
    setCloudModeContext: function setCloudModeContext(context) {
      return repository.setCloudModeContext(context);
    },
    asyncSetCloudModeContext: function asyncSetCloudModeContext(context) {
      return repository.asyncSetCloudModeContext(context);
    },
    on: on,
    off: off,
    close: close,
    loadCache: loadCachedFeatures // 同步载入local storage

  };
  return {
    client: client,
    // The client object containing all public methods.
    options: options,
    // The validated configuration object, including all defaults.
    emitter: emitter,
    // The event emitter which can be used to log error or trigger events.
    logger: logger,
    // The logging abstraction.
    repository: repository,
    // The Repository object.
    start: start,
    // Starts the client once the environment is ready.
    enqueueEvent: enqueueEvent // Puts an feature event in the queue, if disableMetrics is set to false.

  };
}
var version = "1.10.7";

export { createConsoleLogger, errors, initialize, messages, utils, version };
//# sourceMappingURL=toggle-common.es.js.map
